export default {
  domainDirectory: {
    title: "官方網域", subtitle: "請在此核對官方入口。點選網域即可複製。", available: "個目前可連線",
    loading: "正在讀取網域…", loadFailed: "網域讀取失敗", retry: "重新載入", empty: "暫無啟用中的網域",
    tapToCopy: "點選複製", checking: "正在測試", checkingShort: "測試中", online: "可連線", offline: "連線逾時",
    waiting: "等待測試", timeout: "逾時", testAll: "立即測試所有網域", updatedEveryFifteenSeconds: "連線狀態每 15 秒自動測試一次",
    saveReminder: "建議截圖保存本頁，避免網域資訊遺失", copied: "網域已複製",
    names: { primary: "主網域", chinaAccel: "國內加速", secondary: "次級網域" },
  },
  nickname: {"edit": "編輯暱稱", "hint": "2～20位中文、英文字母、數字或底線", "saved": "暱稱已儲存", "taken": "此暱稱已被使用", "invalid": "請輸入2～20位中文、英文字母、數字或底線，不可使用官方保留名稱", "failed": "儲存失敗，請重試"},
  common: {
    confirm: "確認",
    cancel: "取消",
    search: "搜尋",
    language: "語言",
    pleaseRelogin: "登入已過期，請重新登入",
    developing: "功能正在開發中",
    switched: "已切換",
    currentLanguage: "當前語言",
    selectLanguage: "選擇語言",
    loading: "載入中...",
    loadingMore: "載入更多...",
    noMoreData: "沒有更多資料了",
    noData: "暫無資料",
    serverUnavailable: "伺服器暫時不可用",
    loadFailed: "載入失敗",
    requestFailed: "請求失敗",
    retry: "點擊重試",
    projectName: "PANTA MARKET",
    duplicateSubmission: "請勿重複提交",
    fee: "手續費",
    submit: "提交",
    tip: "提示",
    connecting: "連接中...",
    connectWalletFirst: "請先連接錢包",
    connect: "連接",
    insufficientBalance: "餘額不足",
    copyFailed: "複製失敗",
    sessionAuthRelogin: "重新登入",
    sessionAuthStay: "保持",
    pager: {
      prevPage: "上一頁",
      nextPage: "下一頁",
      pageOf: "{page} / {totalPages}",
      jumpToPage: "跳至",
      jumpConfirm: "確定",
    },
  },
  tabbar: {
    home: "首頁",
    market: "時間線",
    timeline: "時間線",
    prediction: "AI 事件合約預測",
    createMarket: "創建市場",
    planet: "理財",
    trade: "交易",
    finance: "理財",
    fund: "基金",
    assets: "資產",
    planethistory: "申購記錄"
  },
  tradeMenu: {
    contract: "事件合約",
    insurance: "保險",
    spot: "現貨",
    flash: "閃兌"
  },
  home: {
    searchPlaceholder: "BTC",
    bannerTitle: "PANTA MARKET",
    bannerSubtitle: "AI 預測 · 事件合約 · 智能分析",
    predictionCategories: {
      hot: "時間線",
      sports: "體育",
      world: "世界",
      politics: "政治",
      economy: "經濟"
    },
    predictionSubCategories: {
      crypto: "現貨",
      forex: "外匯",
      commodities: "貴金屬"
    },
    features: {
      recharge: "充幣",
      rechargeDesc: "快速進行充值",
      contract: "事件合約",
      contractDesc: "創新的金融工具",
      predict: "AI預測",
      fund: "PANTA MARKET Treasury",
      invite: "邀請好友",
      global: "全球節點"
    },
    insurance: {
      title: "合約保險資金池(TAKER)",
      poolTitle: "合約保險資金池",
      aiPoolTitle: "AI 保險池",
      ordinaryPoolTitle: "事件保險池",
      approxUsdt: "≈ ${amount}",
      approxUsdtRef: "≈ ${amount}",
      approxPantaRef: "≈ {amount} PANTA",
      more: "了解更多",
      yesterday: "昨日新增",
      service: "智能客服"
    },
    market: {
      tabs: {
        main: "主流幣",
        hot: "熱門幣",
        rise: "漲",
        price: "價格榜"
      },
      headers: {
        pair: "交易對",
        latest: "最新價",
        change: "今日漲跌幅"
      },
      viewMore: "查看更多",
      collapse: "收起"
    },
    announcement: {
      title: "公告",
      heading: "公告",
      text: "歡迎來到 PANTA MARKET。這裡匯聚事件合約、AI 行情分析與風險保障能力，幫你更快讀懂市場、更從容參與預測交易。",
      time: "2026/03/01 10:00",
      gotIt: "我知道了",
      viewDetail: "查看詳情",
      systemLabel: "系統公告"
    },
    timePeriods: {
      "1min": "1分鐘",
      "30min": "30分鐘",
      "1hour": "1小時"
    },
    footer: {
      australia: "· 澳大利亞",
      uae: "· 阿拉伯聯合酋長國",
      attention: "· 注意:",
      attentionText: "PANTA MARKET 由平台自主運營。我們不會授權任何第三方以官方名義收取費用。如有疑問，請聯繫官方客服：{email}"
    },
    timeframes: {
      "1s": "1分钟",
      "1m": "1分钟",
      "5m": "5分钟",
      "15m": "15分钟",
      "1h": "1小时",
      "4h": "4小时",
      "1d": "1天"
    },
    statusHotEn: "HOT",
    yes: "是",
    no: "否",
    hotBannerTitle: "事件合約",
    homeBanner: {
      s1t1: "基於AI的",
      s1t2: "AstralX核心生態",
      s1cta: "AstralX",
      s2t: "Galaxy基金",
      s2s1: "了解本金保障",
      s2s2: "與收益發放規則",
      s2cta: "去申購",
      s3s: "漲跌預測",
      s3cta: "去預測",
    },
    catCrypto: "加密貨幣",
    catMetal: "貴金屬",
    catSports: "體育",
    catPolitics: "政治",
    catEntertainment: "娛樂",
    statusHot: "熱門",
    statusLocked: "已鎖定",
    statusLive: "進行中",
    statusLockedWait: "已鎖定，等待結算",
    jouleUnit: "JOULE",
    nowLabel: "現在",
    endAtFallback: "--",
    predictionLabel: "漲幅預測",
    rise: "涨",
    fall: "跌",
    viewMoreOptions: "查看更多{n}個選項",
    categoryAll: "全部",
    categoryCrypto: "加密貨幣",
    categoryCommodity: "商品",
    categoryEquity: "股票",
    categoryForex: "外匯",
    categoryMetal: "貴金屬"
  },
  withdraw: {
    title: "提幣",
    headerTitle: "提幣",
    address: "提幣地址",
    addressLabel: "提幣地址",
    addressPlaceholder: "請輸入或粘貼地址",
    network: "網絡",
    selectNetwork: "選擇網絡",
    networkHint: "請確保提幣地址與所選網絡匹配",
    withdrawAmount: "提現數量",
    receiveAmount: "到賬數量",
    networkFee: "網絡手續費",
    submit: "確認提幣",
    submitButton: "提現",
    balance: "餘額：",
    all: "全部",
    amountPlaceholder: "請輸入",
    minimumWithdrawal: "最低提現數量：{amount} USDT",
    minimumWithdrawalTAKER: "最低提現數量：{amount}TAKER",
    fee: "手續費",
    confirm: "確定",
    confirmTitle: "確認操作",
    confirmContent: "是否確認執行該操作？",
    toasts: {
      fetchFailed: "獲取資產失敗",
      enterAddress: "請輸入提幣地址",
      enterValidAmount: "請輸入有效提幣數量",
      insufficientBalance: "餘額不足",
      minimumAmount: "最低提現數量為{amount} USDT",
      processing: "處理中...",
      success: "提幣成功！",
      requestSuccess: "提現申請成功",
      requestFailed: "提現失敗，請重試",
      notConfigured: "提现暂未开放，请稍后再试"
    },
    addressHint: "提币将发送到您的钱包地址"
  },
  deposit: {
    headerTitle: "充值",
    connectPrompt: "請先連接錢包以進行充值",
    loading: "加載中...",
    depositAddress: "充值地址",
    minimumDeposit: "*最小充值 10.0000 USDT",
    depositAmount: "充值金額",
    balance: "餘額",
    amaBalance: "TAKER 餘額",
    amount: "充值金額",
    amountPlaceholder: "請輸入充值數量",
    minimumNotice: "*最小值 {min} {token}",
    processing: "處理中...",
    confirm: "確認充值",
    confirmTitle: "確認操作",
    confirmContent: "是否確認執行該操作？",
    helpText: "充值將調用智能合約的 recharge 方法，需要先授權 TAKER 代幣",
    toasts: {
      copySuccess: "複製成功",
      dataLoadFailed: "數據加載失敗",
      enterValidAmount: "請輸入有效的充值數量",
      invalidAmount: "充值金額不能少於 {min} TAKER",
      invalidAddress: "充值地址無效",
      checkingAllowance: "檢查授權額度...",
      approving: "授權中...",
      approveSuccess: "授權成功",
      depositing: "充值中...",
      depositSuccess: "充值成功",
      depositFailed: "充值失敗",
      balanceLoadFailed: "無法讀取錢包測試幣餘額，請重新整理後再試",
      contractError: "合約調用失敗，請檢查餘額",
      userCancelled: "您已取消操作",
      insufficientFunds: "餘額不足",
      wrongNetwork: "請切換到正確的網絡",
      requestingAuth: "正在請求錢包授權...",
      waitingConfirmation: "等待交易確認...",
      transactionFailed: "交易發起失敗",
      transactionCancelled: "您已取消交易",
      genericError: "交易失敗",
      configNotReady: "充值暂未开放，请稍后再试",
      invalidTxHash: "请输入有效的交易哈希",
      claimPending: "充值已提交，到账处理中",
      cannotGetBalance: "无法获取余额，请刷新后重试"
    },
    depositNotice: "请向以下地址转账，到账后系统会自动处理",
    usdtBalance: "USDT余额"
  },
  team: {
    headerTitle: "我的團隊",
    contractEarnings: "交易收益",
    btcFund: "理財收益",
    stats: {
      personalEarnings: "個人累計收益",
      teamEarnings: "團隊收益",
      personalVolume: "個人流水",
      teamVolume: "團隊流水",
      personalPower: "個人算力",
      teamTotalPower: "團隊總算力",
      periodPersonal: "個人流水",
      periodTeam: "團隊收益",
      totalTeam: "團隊流水",
      personalSubscribed: "個人質押量",
      teamSubscribed: "團隊質押量"
    },
    unclassifiedHint: "歷史賠付來源待覈對：{amount} {asset}",
    links: {
      invite: "邀請好友",
      details: "團隊明細"
    },
    inviteBannerTitle: "邀請好友解鎖團隊佣金",
    inviteBannerSubtitle: "解鎖你的團隊佣金",
    inviteBannerCta: "立即參與"
  },
  my: {
    headerTitle: "我的",
    login: "點擊登錄",
    inviteCode: "邀請碼：",
    groups: {
      common: "常用功能",
      trading: "交易",
      finance: "金融",
      help: "幫助"
    },
    features: {
      invite: "邀請好友",
      team: "我的團隊",
      insurance: "事件合約保險",
      contract: "事件合約",
      exchange: "閃兌",
      fund: "AI金庫基金",
      communitySquare: "社區廣場",
      createEvent: "創建事件",
      community: "官方社區",
      terms: "服務條款",
      announcement: "公告",
      privacy: "隱私政策",
      aboutUs: "關於我們"
    }
  },
  community: {
    title: "官方社群",
    bannerTitle1: "加入我們的社群",
    bannerTitle2: "與全球用戶交流",
    linkCopied: "連結已複製"
  },
  supportPage: {
    title: "聯繫客服",
    hello: "PANTA MARKET 客服中心",
    desc: "當前為示範入口，正式工單系統上線前可透過下方郵箱或社群聯繫我們。",
    emailLabel: "客服郵箱",
    hoursLabel: "服務時間",
    hoursValue: "每日 10:00–22:00（SGT）",
    channelLabel: "推薦渠道",
    channelValue: "官方社群 / 郵箱工單",
    copy: "複製",
    tip: "請勿向任何自稱「官方」的第三方轉帳或授權。平台不會主動索取私鑰與助記詞。",
    goCommunity: "前往官方社群"
  },
  invite: {
    headerTitle: "邀請好友",
    rulesEntry: "邀請規則",
    subtitle: "團隊每筆交易你都能賺",
    mainTitle: "邀請賺傭",
    description: "分享鏈接，朋友交易你拿獎勵",
    bindSuperior: "綁定上級",
    bindPlaceholder: "輸入邀請碼或錢包地址",
    bindButton: "綁定",
    binding: "綁定中…",
    boundLabel: "已綁定上級",
    modalDesc: "尚未綁定上級。可填寫邀請碼或錢包地址，綁定後可參與團隊獎勵。邀請鏈接中的信息會自動填入；無邀請信息時已預填默認上級。",
    later: "稍後",
    yourCode: "你的邀請碼",
    shareLink: "分享鏈接",
    inviteButton: "邀請好友",
    mainTitle_old: "邀請好友一起賺",
    subTitle: "獲得高額返傭",
    viewRules: "查看推薦規則",
    rulesLink: "查看返傭規則 >",
    rulesTitle: "返傭規則",
    rules: {
      commissionTable: {
        title: "PANTA MARKET 交易流水佣金表",
        headers: {
          level: "級別",
          personalTurnover: "自身流水",
          teamTurnover: "團隊流水",
          commission: "團隊佣金"
        }
      }
    },
    inviteBoxTitle: "邀請好友",
    referralCode: "邀請碼",
    inviteLink: "邀請鏈接",
    loading: "加載中...",
    copyButton: "複製邀請鏈接",
    toasts: {
      emptyContent: "內容爲空",
      copySuccess: "複製成功",
      bindSuccess: "綁定成功",
      bindFailed: "綁定失敗",
      alreadyBound: "已綁定上級，不可更換",
      loginFirst: "請先連接錢包",
      invalidCode: "請輸入有效邀請碼或錢包地址",
      cannotBindSelf: "不能綁定自己"
    }
  },
  finance: {
    title: "金融頁面正在開發中..."
  },
  wealthAccess: {
    exchangeThresholdFailed: "兌換失敗，未滿足門檻",
    internalPrice: "內部價",
    marketPrice: "市場價",
    coinBasis: "幣本位",
    legacyBasis: "幣本位",
    contractBasis: "結算類型",
    unitPrice: "成交單價",
    quotaUsed: "內部價累計申購",
    quotaRemaining: "內部價剩餘額度",
    quotaHint: "跨套餐累計限 {limit} PANTA；關閉內部價、到期或等級變更不清零。",
    principal: "本金",
    principalReturn: "到期返還本金",
    dailyYield: "每日毛收益",
    coinYieldHint: "每日毛收益 = PANTA 本金 × 年化比例 ÷ 360，向下取整；幣價變動不影響合約枚數，實際分配按規則執行。",
    legacyHint: "此為幣本位合約；到期 PANTA 還本依合約規定的到期價格折算。",
    quotaError: "超過內部價剩餘額度，請減少數量；不會自動拆單或切換市場價。",
    permissionChanged: "目前 VIP 已無權申購此套餐，清單已更新。",
    quoteChanged: "報價或資格已變更，請核對新報價後再次確認。",
    quoteExpired: "報價已過期，請更新後確認。",
    retryQuote: "更新報價",
    stakeGateTitle: "賣出 PANTA 須符合質押門檻",
    stakeGateBody: "目前 VIP{vip}：有效質押 {staked} PANTA，須 {required} PANTA，尚差 {shortfall} PANTA。僅限制賣出，不影響買入。",
    goStake: "前往質押",
    refreshEligibility: "更新資格",
  },
  fundPage: {
    heroTitle: "每日發放PANTA收益",
    heroDesc: "申購Galaxy基金，獲取年化分紅",
    learnMore: "瞭解更多",
    allProducts: "全部產品",
    subscribe: "申購",
    stake: "質押",
    stakePreview: "質押預覽",
    searchCoin: "搜索幣種",
    allPeriods: "全部週期",
    colCoin: "基金名稱",
    colApy: "幣本位年化",
    colTerm: "期限",
    fixedTerm: "定期",
    galaxyProduct: "Galaxy {n}號",
    termLabel: "期限",
    apyLabel: "年化",
    stakeCap: "個人持倉",
    stakeAmount: "質押金額",
    tradingJouleBalance: "交易帳戶餘額",
    estEarnings: "預計收益",
    stakeDisclaimer: "收益爲參數示意，不構成保證。到賬分配約 70% 至可用餘額、30% 至體驗金；體驗金需完成約 3 倍流水後方可解凍。",
    stakeSuccess: "質押成功",
    annualized: "參考年化",
    perShareYield: "萬份收益(WBS)",
    dayUnit: "天",
    empty: "暫無基金產品",
    loadFailed: "加載失敗",
    rulesTitle: "基金說明",
    gotIt: "我知道了",
    pantaAvailable: "PANTA 可用",
    activeFaceValue: "在投份額",
    totalReward: "基金累計收益(PANTA)",
    fundYieldUnavailable: "--/請更新服務",
    effectiveVip: "有效等級",
    myHoldings: "基金購買記錄",
    faceValue: "價值",
    maturity: "到期",
    stakeStart: "質押時間",
    pantaPrice: "PANTA 單價",
    noMoreHoldings: "沒有更多持倉了",
    subscriptionStatus: {
      ACTIVE: "進行中",
      SETTLED: "已結算",
      CANCELLED: "已取消",
      MANUAL_REVIEW: "人工審核",
    },
    minPanta: "起購 PANTA",
    pantaAmount: "申購數量（PANTA）",
    stepHint: "須爲 {step} 的整數倍，最少 {min}",
    getQuote: "獲取報價",
    confirmStake: "確認質押",
    jouleDebit: "扣除 JOULE",
    expectedPanta: "質押 PANTA",
    quoteExpires: "報價有效至",
    unavailable: "暫未開放",
    invalidAmount: "請輸入符合步長的 PANTA 數量",
    quoteFailed: "報價失敗",
    rewards: "基金獎勵",
    unlock: "PANTA 凍結批次",
    unlockProgress: "已用交易流水",
    pantaLedger: "PANTA 賬本"
  },
  finanfund: {
    title: "PANTA MARKET 財庫基金",
    subtitle: "簡單 高效 輕鬆賺幣",
    productName: "PANTA MARKET 財庫基金",
    minAmount: "單筆最少",
    incomeRatio: "收益比例",
    lockPeriod: "鎖倉週期",
    dailyReturn: "日收益",
    earning: "獲得",
    redemptionRules: "贖回規則",
    rules: {
      rule1: "PANTA MARKET 財庫基金託管後不可贖回",
      rule2: "每日收益自動到賬",
      rule3: "鎖倉金額將以鎖倉結束後返回賬戶"
    },
    subscription: "認購",
    amountPlaceholder: "請輸入",
    balance: "餘額",
    availableFunds: "可用資金",
    all: "全部",
    subscribeButton: "認購",
    toasts: {
      productIdNotExist: "產品ID不存在",
      enterValidAmount: "請輸入有效的認購金額",
      minAmountRequired: "認購金額不能低於{amount}USDT",
      subscribeSuccess: "認購成功",
      subscribeFailed: "認購失敗"
    }
  },
  assets: {
    totalAssetsUsdt: "預估總價值（USDT）",
    availableAssets: "可用資產",
    noHoldings: "暫無持倉",
    mainSystemPanta: "主系統（PANTA）",
    transferToMain: "劃轉到主系統",
    tradeFrozenJoule: "交易凍結(JOULE)",
    insuranceAccountJoule: "保險賬戶(JOULE)",
    payoutPower: "算力節點賠付",
    payoutEquity: "AI預測賠付(JOULE)",
    mainAccount: "交易賬戶",
    insuranceAccountShort: "保險賬戶",
    copyAccountShort: "跟單賬戶",
    tradingAccountHelpTitle: "交易賬戶餘額",
    copyAvailableLabel: "可用餘額",
    copyFrozenLabel: "凍結餘額",
    copyAccountJoule: "跟單賬戶(JOULE)",
    copyTotalPnl: "跟單總盈虧",
    transferSheet: {
      title: "劃轉",
      pairCopy: "交易賬戶/跟單賬戶",
      pairInsurance: "交易賬戶/保險賬戶",
      tradingAccount: "交易賬戶",
      copyAccount: "跟單賬戶",
      insuranceAccount: "保險賬戶",
      jouleHint: "僅支援 JOULE 劃轉",
      submit: "提交",
      transferring: "劃轉中...",
      success: "劃轉成功",
      failed: "劃轉失敗，請重試",
    },
    computeNode: "算力節點",
    stakedTotalPanta: "基金個人質押總額",
    stakedPlusRewardPanta: "質押本金+預計收益",
    stakedPlusRewardTipTitle: "質押本金 + 預計收益",
    stakedPlusRewardTip: "該數值為質押本金與預計總收益之和。",
    stakedPrincipalLabel: "質押本金",
    stakedExpectedYieldLabel: "預計收益",
    annualEarningsPanta: "基金個人收益已發放",
    frozenTotalPanta: "凍結總額",
    unlockedTotalPanta: "累計已解凍",
    fundTeamPendingPanta: "基金團隊收益待發放（PANTA）",
    fundTeamPaidPanta: "基金團隊收益已發放（PANTA）",
    pendingRewardPanta: "今日待空投",
    paidRewardPanta: "已空投",
    expectedAirdropQuota: "預計待空投額度",
    cumulativeAirdropValue: "累計空投價值：{value} USDT",
    roundExpectedValue: "本輪預計價值：{value} USDT",
    historyTotalValue: "歷史總價值：{value} USDT",
    nextAirdropAt: "下次發放時間：{time}",
    airdropEstimateUnavailable: "暫無法估算",
    roundExpectedValueUnavailable: "本輪預計價值：暫無法估算",
    airdropEstimateHint: "預估值，以實際結算爲準",
    roundProgress: "節點生成進度",
    currentNodeCount: "當前節點數",
    deductedNodeCount: "扣除節點數",
    invalidNodeCount: "失效節點數",
    todayRelease: "今日釋放",
    releaseFrozenPanta: "釋放凍結",
    unlockQuota: "解鎖額度",
    unlockQuotaNote: "今日可解鎖額度 0.0000",
    tradeNode: "交易節點",
    tradeNodeDesc: "購買後直接升級 VIP3，解鎖專屬交易權益",
    tradeNodeHint: "購買節點僅獲名額，價格以報價爲準",
    buyNode: "購買節點",
    buyNodeModal: {
      title: "購買交易節點",
      description: "支付{amount}JOULE即可獲得交易節點資格",
      quotePreview: "{name} · {amount} JOULE · 剩餘{remaining}",
      afterBalance: "買後餘額約 {amount} JOULE",
      pickProduct: "選擇節點商品",
      availableBalance: "當前可用餘額",
      cancel: "取消購買",
      confirm: "確認購買",
      purchasing: "購買中...",
      success: "購買成功",
      failed: "購買失敗，請重試",
      insufficient: "餘額不足，請先充值",
      unavailable: "暫未開放"
    },
    tradingAccountRecords: "交易明細",
    wealthAccountRecords: "基金明細",
    insuranceAccountRecordsShort: "保險賬戶記錄",
    detailTitle: "資產明細",
    jouleConvert: "JOULE 折算（×匯率）",
    usdtPart: "USDT 部分",
    jouleAvailable: "JOULE 可用",
    tradeFrozen: "交易凍結(JOULE)",
    financeReleaseFrozen: "理財釋放凍結(JOULE)",
    insuranceFrozen: "保險凍結額度(JOULE)",
    usdtAvailableLabel: "USDT 可用",
    usdtFrozenLabel: "USDT 凍結",
    totalSum: "合計",
    available: "可用",
    deposit: "充幣",
    withdraw: "提現",
    myAccountRecords: "我的賬戶記錄",
    nodeEquityHint: "USDT 计价节点权益，非现金到账",
    nodeEquityRate: "实际发放比例 {rate}%",
    nodeEquitySources: {
      PERSONAL: "普通保险个人权益",
      TEAM: "普通保险团队权益",
      ADMIN: "平台空投",
      AI_INSURANCE: "AI 保险节点权益赔付",
      BACKFILL: "AI 保险节点权益补发",
      OTHER: "节点权益增加",
    },
    recordTypes: {
      NODE_EQUITY_CREDIT: "节点权益增加",
      BET_STAKE: "下注凍結",
      WIN_PAYOUT: "交易盈利",
      LOSS_SETTLEMENT: "交易虧損",
      REFUND: "退款",
      INSURANCE_PREMIUM: "保費支出",
      INSURANCE_PAYOUT: "保險賠付",
      INSURANCE_TRANSFER_IN: "保險轉入",
      INSURANCE_TRANSFER_OUT: "保險轉出",
      NETWORK_DIFFERENTIAL: "交易級差獎",
      NETWORK_PEER: "交易平級獎",
      NETWORK_UNLOCK: "收益解凍",
      EVENT_INSURANCE_PAYOUT: "算力節點賠付",
      EVENT_INSURANCE_PEER: "算力平級獎",
      TRANSFER_IN: "轉入",
      TRANSFER_OUT: "轉出",
      PREMIUM_LOCK: "保費鎖定",
      PREMIUM_SETTLE: "保費支出",
      PREMIUM_REFUND: "保費退回",
      WEALTH_SUBSCRIPTION: "基金申購",
      SUBSCRIPTION_LOCK: "質押鎖定",
      WEALTH_DAILY_REWARD: "基金日息",
      WEALTH_TEAM_REWARD: "基金團隊獎",
      MATURITY_RELEASE: "到期返本",
      WEALTH_UNLOCK: "收益解凍",
      COPY_SHARE_HOLD: "跟單分潤凍結",
      COPY_SHARE_RELEASE: "跟單分潤解凍退回",
      COPY_SHARE_PAYOUT: "跟單分潤支出",
      COPY_TRADE_TRANSFER_OUT: "劃出至跟單賬戶",
      COPY_TRADE_TRANSFER_IN: "從跟單賬戶劃入",
      COPY_WIN_PAYOUT: "跟單盈利",
      COPY_LOSS_SETTLEMENT: "跟單虧損",
      COPY_TRANSFER_IN: "轉入跟單賬戶",
      COPY_TRANSFER_OUT: "轉出跟單賬戶",
      COPY_SHARE_PAYOUT_IN: "跟單分潤入賬",
      COPY_SHARE_POOL_IN: "跟單分潤入池",
      COPY_SHARE_POOL_REFUND: "跟單分潤退回",
      COPY_SHARE_POOL_MIGRATION: "跟單分潤遷移",
      COPY_FLOW: "跟單流水",
    },
    recordCategories: {
      NODE_EQUITY: "节点权益",
      TRADE_PNL: "交易盈虧",
      PREMIUM: "保費支出",
      INSURANCE_PAYOUT: "保險賠付",
      TEAM_REWARD: "團隊獎勵",
      COPY: "跟單明細",
      COPY_TRADE_PNL: "跟單盈虧",
      COPY_SHARE: "跟單分潤",
      COPY_TRANSFER: "跟單劃轉",
      WEALTH_REWARD: "基金日息",
      UNLOCK: "收益解凍",
      PRINCIPAL: "質押/返本",
      TRANSFER: "內部劃轉"
    },
    amountPendingReview: "金額待覈對",
    creditedSplit: "可用到賬{available} · 凍結到賬{frozen}",
    creditedSplitPending: "拆分待覈對",
    afterBalance: "變動後可用{available} · 凍結{frozen}",
    unlockHint: "凍結轉可用，不計新增收益",
    transferFromInsurance: "保險賬戶",
    transferFromMain: "主賬戶",
    all: "全部",
    transfer: "劃轉",
    insuranceDeduction: "保險扣費",
    insurancePayout: "保險賠付",
    noRecords: "暫無記錄",
    frozenOp: "凍結 {amount} {token}",
    lockedOp: "鎖定 {amount} {token}",
    availableChange: "可用 {amount}",
    frozenChange: "凍結 {amount}",
    detail: {
      sessionId: "會話 ID",
      networkReward: "團隊獎勵詳情",
      insuranceClaim: "AI賠付詳情",
      creditStatus: "到賬狀態",
      creditedPendingHint: "已到賬，處理確認重試中",
      orderId: "來源訂單",
      source: "來源"
    },
    actions: {
      deposit: "充值",
      withdraw: "提現",
      exchange: "兌換",
      transfer: "劃轉"
    },
    loginPrompt: {
      text: "請先連接錢包",
      button: "連接"
    },
    toasts: {
      connectFailed: "連接失敗，請重試"
    },
    jouleUsdtRate: "1 JOULE = {rate} USDT",
    pantaUsdtRate: "1 PANTA = {price} USDT"
  },

  wallet: {
    title: "個人資料",
    address: "錢包地址",
    addressCopied: "地址已複製",
    inviteCode: "邀請碼",
    logout: "退出登錄",
    login: "登錄",
    toasts: {
      networkSwitchCancelled: "用戶取消了網絡切換",
      networkConfigNotFound: "未找到網絡配置 {chainId}",
      signatureCancelled: "用戶取消了簽名",
      connectionFailed: "連接錢包失敗",
      accountSwitched: "錢包賬戶已切換，請重新連接",
      connectionTimedOut: "連接超時，請重試",
      loginSuccess: "登錄成功",
      logoutSuccess: "已退出登錄",
      switchNetwork: "請先在錢包中切換到 {chainName} 再嘗試充值",
      wrongChain: "當前網絡不支持，請切換到 {chainName}",
      switchingNetwork: "正在切換網絡...",
      switchNetworkFailed: "網絡切換失敗，請在錢包中手動切換到 {chainName}"
    }
  },
  market: {
    title: "行情",
    banner: {
      title: "事件合約",
      desc: "釋放鏈上賺幣的收益潛力"
    },
    tabs: {
      main: "主流幣",
      rise: "漲幅榜"
    },
    types: {
      crypto: "加密貨幣",
      stocks: "美股",
      forex: "外匯",
      commodities: "貴金屬",
      favorites: "自選"
    },
    headers: {
      pair: "交易對",
      price: "最新價",
      change: "今日漲跌幅"
    },
    loading: "加載中...",
    loadingMore: "加載更多...",
    noMoreData: "沒有更多數據了"
  },
  notice: {
    loginRequired: "請先登入後查看公告",
    empty: "暫無公告",
    unpublished: "已下線",
    current: "當前",
    title: "公告",
    helpCenter: "幫助中心",
    noticeDetail: "公告詳情",
    viewDetail: "查看詳情",
    pdfViewer: "PDF預覽",
    videoPlayer: "視頻播放",
    imageViewer: "圖片預覽",
    documentViewer: "文檔預覽",
    clickToViewPdf: "點擊查看PDF",
    clickToViewDocument: "點擊查看文檔",
    openInBrowser: "在瀏覽器中打開",
    tryingViewer: "正在嘗試方案 {current}/{total}",
    pdfLoadFailed: "PDF預覽加載失敗，請下載查看",
    downloadPdf: "下載PDF文件",
    defaultCategory: "通知"
  },
  trade: {
    title: "事件合約",
    nextRound: "下一輪",
    posCurrent: "當前",
    aiThenPrefix: '當時 AI：',
    aiUnlinked: '未關聯 AI',
    aiNotRecorded: '未記錄',
    insuranceLabel: "保險",
    insuranceNotSelected: '未選擇',
    insuranceInactive: "未生效",
    insuranceTypeNone: "未生效",
    insuranceTypeEvent: "普通保險已投保",
    insuranceTypeEventShort: "普通保險",
    insuranceTypeAi: "AI保險已投保",
    insuranceTypeAiShort: "AI保險",
    insuranceTypeConverted: "本單已轉普通保險",
    insuranceTypeUnknown: "保險狀態待確認",
    inProgress: "進行中",
    estimatedPnl: "預估盈虧",
    settlementConfirming: "結算中，正在確認結果",
    balanceSyncing: "餘額同步中",
    pendingReview: "待核對",
    connecting: "連接中...",
    connectWallet: "連接",
    platformLadder: {
      title: "平臺參考報價",
      current: "現價",
      ask: "賣{n}",
      bid: "買{n}",
      disclaimer: "價格經平臺加工，數量參考交易所，非可成交掛單",
      unavailable: "參考報價暫不可用"
    },
    actions: {
      rise: "買漲",
      fall: "買跌",
      buy: "買入",
      sell: "賣出"
    },
    holdings: {
      current: "當前持倉",
      history: "歷史記錄",
      currentCount: "當前持倉單數 {n}",
      empty: "暫無持倉",
      historyEmpty: "暫無歷史持倉"
    },
    position: {
      openPrice: "開倉價",
      closePrice: "平倉價",
      profitLoss: "盈虧",
      countdown: "距離結算",
      calculating: "計算中...",
      settled: "已結算",
      settling: "結算中",
      syncingTime: "同步時間中",
      active: "活躍",
      settledAt: "結算時間:",
      refunded: "已退款",
      won: "已盈利",
      lost: "已虧損"
    },
    modal: {
      amountPlaceholder: "請輸入金額"
    },
    pairSelector: {
      title: "選擇交易對",
      searchPlaceholder: "搜索幣種",
      ordinary: "事件合約",
      ai: "AI 預測"
    },
    errors: {
      dataNotReady: "數據加載中，請稍候"
    },
    toasts: {
      connectSuccess: "連接成功",
      connectCancelled: "您已取消連接",
      connectFailed: "連接失敗"
    },
    openPriceLabel: "開盤價",
    secondsUnit: "秒",
    amountLabel: "金額",
    premiumBoundEstimate: "已綁定策略預計保費 {premium} JOULE",
    premiumShortfallHint: "保險賬戶還差 {amount} JOULE，無法開啓",
    mainBalanceInsufficient: "主賬戶餘額不足",
    recoverContent: "檢測到未確認事件合約訂單（{symbol} {direction} {amount}）。將使用原冪等鍵確認，不會重複下單。",
    orderSuccess: "下單成功！",
    insuranceBalanceRequired: "保險賬戶餘額不足，無法開啓保險",
    premiumEstimateUnavailable: "暫無法估算保費",
    insuranceMainRequired: "主賬戶餘額不足，無法開啓保險",
    insuranceRulesUnavailable: "保費規則未就緒，無法開啓保險",
    premiumEstimate: "預計保費 {premium} JOULE（{rate}%）",
    marketPause: {
      default: "市場暫不可交易，請稍後再試",
      lastPriceStreamWarming: "最新價行情準備中，請稍後再試",
      marketWarming: "市場預熱中，請稍後再試",
      recovering: "行情恢復中，請稍後再試",
      clockNotSynced: "服務器時間未同步，請稍後再試",
      symbolUnavailable: "該交易對暫未開放"
    },
    orderConfirming: "正在確認下單結果，請勿重複操作",
    recoverCancel: "取消",
    insuranceConfirmTitle: "確認保費",
    preferenceSessionEndedSaveFailed: "輪次已結束，關閉設置未保存",
    insuranceBalanceInsufficient: "保險賬戶餘額不足",
    recoverConfirm: "確認訂單",
    orderFailed: "下單失敗",
    preferenceLoadFailed: "保險設置加載失敗，請重試",
    preferenceSaveFailed: "保險設置保存失敗，請重試",
    recoverTitle: "恢復未確認訂單",
    preferenceLoading: "保險設置加載中",
    insuranceConfirmBody: "預覽保費 {premium} JOULE。以預覽結果爲準，確認後提交。",
    orderNotFilled: "本次下單未成交，未扣款",
    unsettledIntervalConflict: "同幣種同週期已有未結訂單，請等待結算或更換週期",
    invalidInterval: "週期參數無效，請重新選擇",
    chartPlatform1mOnly: "該品種圖表僅支援平台 1 分鐘行情",
    orderDetail: {
      title: "訂單詳情",
      orderId: "訂單號",
      symbol: "交易對",
      interval: "週期",
      direction: "實際方向",
      aiDirection: "當時 AI",
      openTime: "開倉時間",
      settleTime: "到期時間",
      settledAt: "結算時間",
      openPrice: "開倉價",
      closePrice: "結算價",
      stake: "本金",
      premium: "保費",
      netProfit: "淨盈虧",
      status: "狀態",
      orderSource: "訂單來源",
      converted: "保險轉換",
      notRecorded: "未記錄",
      copied: "訂單號已複製",
    },
    orderStatus: {
      CREATED: "已創建",
      ACCEPTED: "已受理",
      CLOSED: "已關閉",
      FUNDS_LOCKED: "資金已鎖定",
      AWAITING_SETTLEMENT: "待結算",
      PROCESSING: "處理中",
    },
  },
  exchange: {
    title: "兌換",
    from: "從",
    to: "至",
    balance: "餘額",
    all: "全部",
    placeholder: "請輸入",
    fee: "手續費",
    minAmount: "最低兌換數量：{amount} {symbol}",
    button: "提交",
    tradeButton: "交易",
    paymentCurrency: "支付幣種",
    estimatedGasFee: "預估Gas費用",
    gasPaymentNote: "將使用GetGas餘額支付Gas費用",
    slippage: "滑點",
    auto: "自動",
    approximately: "約",
    minReceived: "Min 獲得",
    exchangeRate: "兌換率",
    finalAmount: "最終獲得金額",
    confirm: "確認",
    swapSuccess: "閃兌成功！",
    swapping: "閃兌中...",
    confirmTitle: "確認操作",
    confirmContent: "是否確認執行該操作？",
    rateHint: "{usdt} USDT = {joule} JOULE",
    rateHintPair: "{from} {fromSymbol} = {to} {toSymbol}",
    rateHintUsdtToJoule: "淨到賬以報價爲準",
    rateHintJouleToUsdt: "含兌換費，淨到賬以報價爲準",
    rateHintPantaFree: "暫免手續費，淨到賬以報價爲準",
    feeZero: "手續費：0（暫免）",
    feeLabel: "手續費：{fee} {symbol}",
    grossLabel: "扣費前：{amount} {symbol}",
    netLabel: "淨到賬：{amount} {symbol}",
    pantaEffectivePrice: "PANTA 生效價：{price} U",
    pantaViaUsdtHint: "按 USDT 折算：{price} U/PANTA · 1 U = {joulePerUsdt} JOULE",
    quoting: "報價中…",
    configFee: "Joule → USDT 手續費 {fee}",
    configLimits: "手續費 {fee} · 扣費前價值限額 {min}–{max} U",
    unlimited: "不限",
    quoteFailed: "暫無法獲取報價，請重試",
    toasts: {
      fetchFailed: "獲取資產失敗",
      enterValidAmount: "請輸入有效金額",
      minAmount: "最低兌換數量爲{amount} {symbol}",
      swapSuccess: "兌換成功",
      requestFailed: "請求失敗",
      insufficientBalance: "餘額不足，無法兌換",
      usdtRestricted: "USDT 資金審覈中，暫不可兌換",
      quoteExpired: "報價已失效，請重新確認",
      amountStepInvalid: "兌換數量不符合步進要求，請調整後重試"
    }
  },
  globalNode: {
    title: "節點"
  },
  eventInsurance: {
    title: "事件合約保險",
    availableBalance: "可用餘額",
    fundTransfer: "資金劃轉",
    lockedBalance: "不可劃轉",
    fundHistory: "保險資金記錄",
    type: "類型:",
    all: "全部",
    transfer: "劃轉",
    insuranceDeduction: "保險扣費",
    insurancePayout: "保險賠付",
    fundTransferTitle: "保險資金劃轉",
    currency: "幣種",
    from: "從",
    to: "到",
    availableAccount: "可用賬戶",
    contractAccount: "合約賬戶(TAKER)",
    contractInsuranceAccount: "合約保險賬戶",
    pleaseEnter: "請輸入",
    confirmTransfer: "劃轉",
    insufficientBalance: "餘額不足",
    transferSuccess: "資金劃轉成功！",
    transferFailed: "資金劃轉失敗，請重試！",
    transferring: "資金劃轉中...",
    noRecords: "暫無記錄",
    selectAccount: "選擇賬戶",
    cannotTransferToSameAccount: "無法劃轉到同一賬戶",
    cannotTransferContractAccount: "暫不支持合約賬戶劃轉",
    equityTitle: "普通保險權益",
    personalEquity: "個人權益",
    teamEquity: "團隊權益",
    equityNodes: "有效節點",
    premiumRules: "倉位閾值 {threshold}% · 低檔保費 {low}% · 高檔保費 {high}%（本單以預覽爲準）",
    remainingEquity: "剩餘權益",
    peersPaid: "平級已付",
    peersPending: "平級待付",
    recentPayouts: "近期日結",
    creditsCount: "權益筆數",
    nodeBatches: "節點批次",
    peerRows: "待付平級筆數",
    rulesTab: "速覽",
    agreementTab: "完整協議",
    insuranceRulesTitle: "保險規則",
    preview: {
      eventGroup: "一.事件合約預測規則協議",
      eventOpen: {
        title: "1. 保險開啟",
        points: [
          "開啟保險後將按下單金額與交易賬戶餘額佔比收取保費：下單金額不超過賬戶餘額 10% 即收取 15% 保費；超過即收取 20%。",
          "若保險賬戶餘額不足，保險不生效"
        ]
      },
      eventLimit: {
        title: "2. 下單閾值",
        points: [
          "單筆下單上限為 5,000 JOULE"
        ]
      },
      eventClaim: {
        title: "3. 賠付權益規則",
        ok: [
          "賠付金額的 50% 進入個人賠付空投額度，累計至 50 美金即獲得一個算力節點",
          "賠付金額的 30% 進入社區賠付空投額度，按社區VIP等級規則分配，累計至 50 美金即獲得一個算力節點"
        ],
        fail: [
          "失去全部下注本金，預測終止"
        ]
      },
      eventPool: {
        title: "4. 事件保險池賠付：",
        points: [
          "系統將按事件保險池每日資產總額 2% 的PANTA，用於所有合格用戶算力節點加權平均空投",
          "用戶獲得事件保險池每日空投累計至 50 美金的PANTA時，即減少一個算力節點"
        ]
      },
      eventProfit: {
        title: "5. 盈虧規則",
        points: [
          "預測正確：用戶獲得「本金 100% + 盈利 (80%)」",
          "預測錯誤：失去全部下注本金，預測終止"
        ]
      },
      aiGroup: "二.AI事件合約預測規則協議",
      aiFirst: {
        title: "1. 首單需用戶手動輸入"
      },
      aiOpen: {
        title: "2. 保險開啟",
        points: [
          "開啟保險後，下單需要支付倉位金額 5%——10% 的金額作為保費",
          "若保險賬戶餘額不足，保險不生效"
        ]
      },
      aiLimit: {
        title: "3. 下單限制",
        points: [
          "下單金額需嚴格按倉位表檔位執行，且每次下注方向需要與AI預測方向一致",
          "若未按倉位表檔位執行，即轉為普通事件合約預測",
          "連續虧損 8 單，即可執行規定比例賠付權益",
          "若產生盈利訂單，執行重置下單序列，即第1單"
        ]
      },
      table: {
        level: "賬戶等級",
        order1: "第1單",
        order2: "第2單",
        order3: "第3單",
        order4: "第4單",
        order5: "第5單",
        order6: "第6單",
        order7: "第7單",
        order8: "第8單"
      },
      claimOk: "符合賠付條件",
      claimFail: "不符合賠付條件",
      claimFailWhen: "不符合賠付條件時：",
      claimPrereq: "賠付前提：",
      aiClaim: {
        title: "4. 賠付權益機制",
        prereq: [
          "保險已開啟",
          "下注與AI預測方向一致",
          "金額與倉位表檔位順序一致",
          "滿足完整結算條件"
        ],
        ok: [
          "現金賠付 = 累計虧損金額 x 90%"
        ],
        fail: [
          "失去全部下注本金，預測終止"
        ]
      },
      aiProfit: {
        title: "5. 盈利規則",
        points: [
          "預測正確：用戶獲得「本金 100% + 盈利 80%」",
          "預測錯誤：失去全部下注本金，預測終止或按賠付權益賠付"
        ]
      }
    },
    rulesContent: "PANTA Market 事件合約交易保障計劃保險協議\n\n【重要提示】使用本服務前，請務必仔細閱讀並充分理解協議全部內容。系統將通過用戶觸發開啟「保險開關」即視為您已充分閱讀、理解並接受協議及附件內容，確認協議具有法律約束力，並同意嚴格遵守；若不同意且不接受，請立即停止使用其保障計劃。\n\n第一條：協議總則與適用範圍\n\n1.1 本協議用於說明 PANTA Market 內“事件合約預測”、“AI事件合約預測”兩類功能的參與方式、訂單成立、費用、結果判定、資金結算、條件性賠付及相關節點權益及事件預測功能。兩類產品分別適用其專門條款，不能將其中一種產品的費率、賠付條件或節點規則直接套用到另一種產品。\n1.2 事件合約預測是用戶對事先列明的事件及其可選結果作出判斷，並使用 JOULE 提交且創建訂單的功能。其最終合格虧損可按批准規則生成個人或社區團隊節點額度；該額度不是即時現金賠付。AI事件合約預測是用戶參考系統提供的有效AI預測方向信號，按照選定方案的固定金額和秩序逐筆確認參與創建訂單的功能。同一合格序列的 8 筆訂單完整結算且全部虧損，並同時滿足其他明確條件時，按合格本金合計的90%計算 JOULE 賠付。AI信號不是結果保證，條件性賠付也不覆蓋全部支出。\n1.3 本協議、對應產品的版本化參數、具體事件規則和用戶確認頁面應共同構成完整規則。頁面只能展示已經批准的參數，不得用“以頁面為準”替代關鍵條件的缺失。文件間發生矛盾時，應停止新增受影響交易並說明、核驗和糾正，不得在事後單方選擇對用戶更不利的解釋處理存量訂單。\n1.4 本項目涉及真實資產、事件預測、條件性賠付及保險稱謂、團隊獎勵、兌換和資金池，不屬於可以省略風控合規評審的產品。各項功能的法律定性、許可、可提供地區、用戶資格、反洗錢、消費者保護及數據處理要求，應按實際服務範圍完成專業核驗。免責聲明不能替代必要許可、資金安排和控制措施；本稿不預設適用某一國家法律，也不認定產品已合法獲准運營。\n\n第二條：術語與資金狀態\n\n2.1 JOULE 是本產品設計中用於預測本金、保費及AI賠付計量的單位；PANTA 是節點權益分配等業務使用的資產單位；USDT 等值是部分額度和價值測算使用的計量口徑。三者不能混用，內部數值展示不意味著可以按固定匯率即時兌換為法定貨幣，也不等於鏈上資產轉移已經完成；該說明不取消已經依法依約形成的資產權益或支付義務。\n2.2 下單本金，是用戶在某筆訂單中實際確認並被系統接受的 JOULE 金額，不包括保費。保費，是按該筆訂單適用規則計算的費用。凍結總額通常為本金與保費之和，另有費用時必須事前分別披露，不能在結算時追加未確認收費。\n2.3 可用餘額，是在當前賬戶規則下可用於新增操作的餘額。凍結餘額，是已為接受的訂單或批准的業務預留、暫不能用於其他操作的餘額。預計收益、待審賠付、節點額度和未入賬分配均不計入可用餘額。餘額展示應註明資產名稱，不允許將不同資產數量直接相加。\n2.4 AI序列，是用戶針對同一已確認方案，從第1筆開始按規則銜接的業務記錄。當前步驟、訂單結果和資格證據由服務端維護。正常斷網或退出APP不構成序列業務終止；重置是符合本協議規定條件後終止舊序列。\n2.5 算力節點額度，是依據最終合格虧損按規則累計、用於生成節點的 USDT 等值記賬單位。節點，是參與後續權益分配的資格記錄，不是即時現金、已到賬 PANTA，也不因名稱而成為可交易、質押或自由轉讓的鏈上 NFT。\n2.6 規則快照，是訂單或序列確認時保存的規則版本、參數、金額、價格依據、條款和相關證據。新版本發佈不能覆蓋舊快照。服務端記錄用於核驗操作狀態，但用戶可以提供其他證據申請複核，不能僅因記錄由平臺保存而排除合理異議。\n\n第三條：使用資格與確認協議\n\n3.1 平臺僅可向已經批准的服務地區、年齡範圍和適當性範圍內的用戶提供相應功能。正式版本應明確身份核驗要求、產品可用範圍及限制原因。不能僅憑用戶錢包已連接、界面可見或賬戶有餘額，認定其具備所有產品的參與資格。\n3.2 用戶應使用本人有權控制的賬戶和資產，不得冒用身份、未經授權使用他人賬戶、偽造資格資料、操縱信號或結果證據。平臺需要補充核驗時，應說明所需資料與業務目的；對新參與的限制和既有訂單的履約處理應分別說明。\n3.3 用戶在下單前應能查閱本金、保費、可能的額外費用、預測選項、最壞損失、結算條件、判定來源和爭議路徑。平臺應提供清晰的確認步驟，不應通過默認同意、隱藏費用、自動切換金額或催促重複操作代替用戶的真實確認。\n3.4 AI信號、歷史結果、示例收益、節點池規模及他人權益記錄均不構成未來結果承諾。用戶可能損失已接受訂單的本金及相關保費，節點權益也可能受池餘額、有效權重、價格和處理狀態影響。用戶不應把某個示例當作本人的固定收益或確定回收期限。\n\n第四條：事件合約預測規則\n\n4.1 用戶開始AI序列前，應查看可用方案、執行倉位本金、預計保費、合計資金需求、信號有效期、60秒結算規則及90%賠付條件。新序列只能從第1筆開始，方案在序列進行中不得切換；用戶不能用跳步、改額或並行未結訂單組合為新的合格序列。 用戶選擇事件結果並輸入 JOULE 本金後，平臺依據已經批准的倉位基數計算保費。當前設計為：本金不超過倉位基數的10%時，保費為本金的15%；超過倉位基數的10%時，保費為本金的20%。恰好等於10%邊界時適用15%。\n4.2 AI信號應顯示標的、方向、時間、有效期和可識別的信號編號。用戶下單時須確認與當時有效信號一致的方向。信號在等待或重連期間更新，應重新核驗；過期信號不能被客戶端緩存繼續使用。採用AI信號不表示平臺或算法知道未來結果。歷史準確率、演示記錄和預測解釋不能作為本筆結果保證。平臺不得用“保贏”“穩賺”或“錯誤也無損”等表達替代實際本金、保費和賠付條件。\n4.3 每個事件應獨立列明名稱、事實描述、可選結果、開放和封盤時點、時區、參與限額、結果判定標準、主要與備用證據來源、盈利計算、最壞損失、取消或延期規則及申訴安排。對模糊事件、缺失判定標準或關鍵經濟參數未批准的事件，不得開放真實下單。平臺應在接單時複核事件仍處於開放狀態、服務端時間早於封盤時點、選項及版本有效、用戶資格與限額滿足、餘額足夠。封盤判斷不以用戶設備時間為準，也不以用戶點擊時客戶端仍顯示倒計時為準。\n4.4 本金及保費成功凍結、訂單接受後，平臺返回接受時間和約定結算時點。該時點按服務端接受時間加 60 秒計算，不從用戶打開頁面、收到信號或點擊按鈕時計算。網絡延遲不會縮短或延長已經確定的判定口徑。60秒錶示約定的結果判定時點，不承諾在客戶端倒計時歸零的同一瞬間完成資金到賬。到點後應獲取約定來源的結果證據；無證據、來源異常或結果衝突時保持待結算並說明狀態，不能自動記作虧損。\n4.5 只有在當前有效序列、規則已清楚展示、無未結訂單的情況下，用戶確實提交與有效信號不一致的方向或與當前固定步驟不一致的金額，才適用拒單並終止舊序列的重置設計。應展示具體原因、受影響序列及下一可執行操作，並保留原歷史。重置後，下次可以從第1筆建立新序列，不能將舊序列已虧訂單與新序列訂單拼接計算8連虧。舊序列已完成的損益保留，不自動獲得90%賠付；但不影響用戶就平臺錯誤、錯誤重置或其他爭議申請複核。\n4.6 被拒絕的違規請求本身沒有成交，不產生新增本金損失、保費或虧損節點。原材料中關於違規虧損轉節點的表述尚未形成可執行規則，不能據此給拒單虛構虧損或補償。\n4.7 用戶暫停發起後續步驟，不等於已經形成8連虧；未完成序列不能請求按已虧筆數比例獲得90%賠付。序列主動終止、長期停留和恢復期限尚需正式規則確認，不得自行增設一段未披露的失效時間。正常退出和斷網不得解釋為主動放棄。同一序列須同時滿足以下四類條件，方可按當前設計計算90% JOULE 賠付：每筆保險機制有效開啟且當單本金及保費實際凍結成功；每筆方向與接受時有效 AI 信號一致；每筆本金和步驟順序符合已確認方案；8筆全部完整結算且結果全部為合格虧損，即可獲取賠付。賠付金額為合格 8 筆參與本金合計乘90%，以 JOULE 計量並支付；保費不進入該 90% 基數。賠付不能直接表述為返還全部支出的 90%，也不自動折算為 USDT、現金或 PANTA。其他資產兌換仍需獨立規則和授權。\n4.8 賠付資格成立與支付成功是兩個階段。具備資格但資金不足、賬務異常或存在適用限制時，保留待支付義務和明細，顯示處理中或明確的掛起原因，後續依法依約處理；不得把支付困難改寫為用戶不符合資格。\n4.9 賠付以該序列唯一記錄執行一次。支付成功但響應丟失，後續查詢和重試應返回原結果，不重複支付。支付失敗應保持真實未完成狀態，不要求用戶新建序列或重新下單來“激活”原賠付。同一序列如依事先確認機制允許各筆採用不同費率，應逐筆保留快照並累計實際費用；不能簡單使用某一個當前費率重算所有歷史訂單。影響已確認序列的費率機制變更，應先明確其適用範圍，不可通過新頁面追溯增加成本。\n4.10 資產最小單位、精度、逐筆舍入方法及尾差處理應在發佈前確定並保持一致。頁面為便於閱讀的四捨五入不得改變賬務明細；計算示例保留的精度不是已經批准的支付精度。手續費、價格差及尾差不得以合併顯示方式隱藏。\n\n第五條：系統服務\n\n5.1 斷網或請求超時：用戶先查詢原訂單，平臺返回已經接受、明確拒絕或仍待確認的實際狀態。原結果未知時不得誘導重複付款；後續確認為未接受時，才按當前有效規則再次確認新請求。\n5.2 信號或報價過期：拒絕舊請求，顯示原因並重新獲取內容。不得靜默替換為新方向、新金額或新費用，也不得將過期自動視為 AI 違規重置。若舊請求已經被接受，仍按其快照履行。\n5.3 結果或價格異常：暫停受影響判定、估值或分配，提供狀態、受影響範圍及查詢渠道。缺失結果不能記失敗虧損，異常估值不能用於擴大虧損基數。更換備用來源應遵守事先公佈的來源順序和異常規則。\n5.4 賬務差異或外部交易狀態未知：先核驗原記錄及外部回執，不重複發送不可逆動作。確認失敗後按相應規則解凍或重試；未知不等於已退款。已完成的用戶資金動作與未完成的後續購幣、入池子步驟應分別展示。\n5.5 資金短缺：停止新增可能擴大缺口的相關業務、保留已形成義務、告知待處理狀態，並按批准方案處理。不得偽造已到賬、將用戶可用餘額改為負數或用未告知的額外收費填補差額。\n5.6 風險限制：平臺可以依正式批准並適當披露的規則進行必要核驗或限制，但應區分限制新單、延遲支付和取消資格。限制不得自動改寫歷史輸贏或已滿足的經濟條件；適用例外應有事實與依據，並提供可用的複核渠道。\n5.7 維護、停止服務或關閉某產品時，歷史訂單、賠付、爭議和可核對記錄仍應有處理安排。用戶不能新增交易不代表其已有餘額、應付賠付或申訴權消失。關閉新業務開關不得順帶關閉全部歷史查詢和履約流程。\n\n第六條：免責條款\n\n以下情形引起的虧損，服務費不承擔賠償責任\n6.1 用戶不遵守策略：任何偏離本平臺標準倉位管理規定的行為\n6.2 極端市場條件：因交易所癱瘓、流動性枯竭、市場操縱引起的虧損\n6.3 系統與運營風險：因用戶設備故障、操作失誤、賬戶被盜等引起的虧損\n6.4 政策與合規風險：因法律、法規或監管命令變更導致的交易中斷或禁止\n6.5 內在代幣風險：JOULE市值大幅度下跌或崩潰，影響其作為保證金和結算貨幣功能\n6.6 欺詐與惡意行為：用戶涉及欺詐、洗錢、市場操作或其他違法活動\n6.7 不可抗力：因不可抗力導致的本平臺系統故障\n\n第七條：風險紕漏\n\n用戶確認已充分理解並接受以下風險：\n7.1 不保本、不保利：本計劃僅對部分虧損提供賠償，絕對無法保證本金安全或盈利\n7.2 策略依賴風險：保障效果完全取決於對策略的嚴格遵守\n7.3 流動性與鎖定風險：賠償資金進入財富管理賬戶，可能涉及投資風險及鎖定期，影響資金流動性\n7.4 第三方風險：所依賴的交易所存在運營、安全及價值波動風險\n7.5 監管不確定性風險：本平臺面臨全球監管不確定性及被叫停的風險\n7.6 技術安全風險：包括因智能合約漏洞、黑客攻擊等導致的資產損失風險\n\n第八條：協議變更、終止與爭議\n\n8.1 協議變更：本平臺保留根據法律法規或運營需要修訂本協議的權利，重大變更將通過平臺公告通知\n8.2 協議終止：用戶可隨時關閉保障開關終止服務；若用戶違反協議，平臺可單方面終止；因法律或政策原因本計劃可能終止用行\n8.3 爭議解決：因本協議產生的爭議應通過友好協商解決；協商不成功將提交至指定仲裁機構或法院解決\n\n【最終確認】您理解並同意「啟用保險開關」是您確認受本協議全部內容約束的唯一且最終方式，請基於獨立判斷做出決定。"
  },
  walletBind: {
    connectWallet: "連接",
    inputPlaceholder: "輸入地址",
    bind: "綁定",
    binding: "綁定中",
    tip: "提示：連接錢包出了問題，可嘗試手動輸入錢包地址綁定"
  },
  loginModal: {
    title: "登入 PANTA MARKET",
    connectWallet: "連接",
    connecting: "連接中...",
    alreadyConnected: "已連接",
    tip: "提示: 連接錢包出了問題，可嘗試手動輸入錢包地址綁定",
    inputLabel: "輸入錢包地址",
    inputPlaceholder: "0x234d456f6798...",
    bind: "綁定",
    binding: "綁定中",
    bindSuccess: "綁定成功",
    bindSuccessHint: "綁定成功，請重新登錄",
    bindFailed: "綁定失敗",
    noAuthCode: "缺少授權碼",
    invalidAddress: "無效的錢包地址格式",
    confirmTitle: "確認綁定",
    confirmWarning: "請仔細確認以下地址是否為您的錢包地址，綁定後將無法修改",
    addressLabel: "錢包地址",
    cancel: "取消",
    confirm: "確認綁定",
    loginSuccess: "登入成功",
    openWalletApp: "打開 {wallet}",
    openWalletConnect: "打開 {wallet} 連接",
    openWalletSign: "打開 {wallet} 簽名",
    returnToBrowser: "完成後請返回本頁繼續",
    loginStepLabel: "第 {step}/2 步",
    stepConnectTitle: "連接錢包",
    stepConnectHint: "請在錢包中批准連接請求，完成後返回本頁",
    stepConnectHintWithOpen: "點下方打開錢包並批准連接，完成後返回本頁",
    stepSignTitle: "簽名登入",
    stepSignHint: "請在錢包中簽署登入訊息（不會轉出資產），完成後返回本頁",
    stepSignHintWithOpen: "還需簽名一步：點下方再次打開錢包簽署登入訊息",
    waitingWalletReturn: "等待錢包授權",
    waitingWalletHint: "請在錢包中確認，完成後請返回本頁",
    waitingWalletHintShort: "若未自動跳轉，請點下方打開錢包",
    retryLogin: "重試登入",
    networkRequired: "需要切換網路",
    networkRequiredHint: "請切換到 {chain}，返回本頁後重試",
    switchingNetwork: "確認切換網路",
    switchingNetworkHint: "請在錢包中確認切換到 {chain}",
    signatureRequired: "請簽名登入",
    signatureHint: "請在錢包中簽名，不會轉出資產",
    verifyingLogin: "正在驗證",
    verifyingHint: "請稍候",
    connectFailed: "連接未完成，請重試"
  },
  walletProfile: {
    title: "個人信息",
    address: "地址",
    accountName: "賬號名稱",
    inviteCode: "邀請碼",
    deactivateAccount: "註銷賬號",
    logout: "退出登錄",
    switchAccount: "登錄其他賬號",
    confirmLogout: "確定要退出登錄嗎？",
    loggingOut: "正在退出...",
    confirmSwitch: "確定要切換賬號嗎？當前賬號將退出登錄",
    developing: "功能開發中",
    addressCopied: "地址已複製",
    inviteCodeCopied: "邀請碼已複製"
  },
  aiPrediction: {
    stakeAutofill: "AI 輔助",
    stakeAutofillWarning: "僅提供輔助，推薦金額可能出錯，下單前請核對。網路延遲超過 800ms、檢測失敗或過期時暫停回填，恢復後自動繼續。不影響手動下單。",
    stakeAutofillUnavailable: "網路不穩定或延遲超過 800ms，暫不能開啟",
    stakeAutofillPaused: "網路不穩定，回填已暫停，可手動輸入",
    insuranceSyncing: "正在同步保險倉位…",
    predictionBuffer: '預測準備中',
    scheduleResultPending: '本輪結果暫不可用，正在重試',
    recovery: {
      checking: '正在核實上次預測結果，不會重複扣次',
      pending: '上次預測仍在處理中，正在自動核實',
      unknown: '暫時無法確認上次結果。連線後自動核實，也可點擊重試',
      released: '上次預測已取消或未生成結果，預占次數已釋放',
      recovered: '已恢復上次預測結果，未重複扣次，下單截止時間不變',
      expired: '上次預測已生成並計次，但下單視窗已過期，不能重新下單',
      available: '已找回自主預測結果，正在等待時間同步或當前操作結束',
      bullish: '預測方向：看漲', bearish: '預測方向：看跌',
    },
    tierSelection: "AI保險檔位",
    tierSaving: "正在確認檔位，請勿重複操作",
    tierUnknown: "檔位結果待確認，點擊查詢並重試",
    tierPending: "待應用檔位（以服務端確認結果爲準）",
    ordinaryPreviewHint: "當前金額不符合AI倉位，將按普通保險預覽並確認",
    title: "AI預測",
    bookingTitle: "AI 場次預約",
    bookingExpand: "展開",
    bookingCollapse: "收起",
    bookingNextSystem: "系統下一場 · SGT",
    bookingNextMine: "我預約的下一場",
    bookingNone: "暫無",
    bookingStartingSoon: "已預約場次即將開始",
    bookingToday: "今天",
    bookingTomorrow: "明天",
    bookingTimezone: "SGT",
    bookingQuota: "剩餘可參加 {remaining}/{dailyLimit} 場",
    bookingSeats: "{occupied}/{capacity} 人",
    bookingEmpty: "暫無可用場次",
    bookingWaiting: "請等待當前預測結束，結束後將自動入場",
    bookingEnded: "已結束",
    bookingJoin: "加入本場",
    bookingReserve: "預約",
    bookingJoined: "已入場",
    bookingReserved: "已預約",
    bookingFull: "已約滿",
    bookingConfirm: "確認預約",
    bookingWarning: "預約成功即佔用該日 1 次機會，未參加也計次。",
    bookingQuotaExhausted: "當日可參加場數已用完",
    bookingUnavailable: "當前不可預約",
    bookingFailed: "預約失敗，請刷新後重試",
    countdown: "倒計時",
    expectedProfit: "預計盈利",
    active: "活躍",
    aiAnalysis: "AI智能漲跌概率分析",
    updateTime: "更新時間",
    probabilityUp: "買漲概率",
    probabilityDown: "買跌概率",
    startPrediction: "啓動預測",
    startAIPrediction: "開啓AI預測",
    scheduleConfirm: "跟隨下單",
    scheduleBinding: "綁定信號中...",
    ruleScore: "規則評分 {score}，不是獲勝概率",
    selectTier: "請選擇保險檔位",
    scheduleUnscheduled: "暫未安排",
    scheduleWaiting: "等待下一時段",
    schedulePreparing: "第 {round} 輪準備中",
    scheduleUnavailable: "當前不可下單",
    scheduleFinished: "本輪已結束",
    predicting: "預測中...",
    stayOnPageHint: "請勿離開當前頁面，否則預測結果可能丟失",
    waitingResult: "等待結果",
    predictionResult: "預測結果",
    nextRound: "下一輪",
    aiPool: "AI保險池",
    orderWindowLabel: "下單剩餘",
    eventContract: "事件合約",
    stakeFromStrategy: "倉位由策略指定",
    stakeTier: "檔位 {tier}",
    stakeStep: "第 {step} 步",
    tierMatched: "已匹配{tier}檔 · 第{step}/{total}步",
    tierBound: "當前{tier}檔 · 第{step}/{total}步，本步要求 {amount} JOULE",
    tierBoundNoStake: "當前{tier}檔 · 第{step}/{total}步",
    amountNotAi: "當前金額不符合AI保險要求",
    amountInvalid: "請輸入至少 0.1 JOULE，最多 18 位小數",
    tierAmbiguous: "保險檔位規則有歧義，暫不能開啓",
    premiumEstimateAmount: "預計保費 {premium} JOULE",
    ordinaryInsuranceTitle: "本單爲普通保險",
    ordinaryInsuranceBody: "本單爲普通保險，不屬於AI輪次賠付。確認後按預覽保費提交。",
    sessionConflict: "已有進行中的AI保險輪次，請先恢復或結束後再下普通保險",
    conversionTitle: "確認轉換爲普通保險",
    conversionDesc: "本單將轉爲普通保險並結束本輪AI保險，此前累計AI連虧不賠付。普通保險保費 {premium} JOULE。",
    conversionConfirm: "確認轉換並下單",
    orderSuccess: "AI預測下單成功！",
    orderFailed: "AI預測下單失敗",
    orderConfirming: "正在確認 AI 預測下單結果，請勿重複操作",
    orderNotFilled: "本次 AI 預測下單未成交，未扣款",
    recoverTitle: "確認未完成 AI 預測訂單",
    recoverContent: "檢測到未確認 AI 預測訂單（{symbol} {direction} {amount}）。將使用原冪等鍵確認，不會重複下單。",
    recoverConfirm: "確認訂單",
    recoverCancel: "取消",
    userInfo: "用戶信息",
    predictCount: "預測次數",
    freeCount: "免費預測次數",
    openTime: "開啓時間: {time1}",
    up: "漲",
    down: "跌",
    rise: "買漲",
    fall: "買跌",
    notConnected: "未連接",
    count: "次數",
    learnMore: "瞭解更多",
    calculating: "計算中...",
    settled: "已結算",
    settling: "結算中",
    syncingTime: "同步時間中",
    settledAt: "結算時間:",
    refunded: "已退款",
    won: "已盈利",
    lost: "已虧損",
    position: {
      calculating: "計算中...",
      settled: "已結算",
      settling: "結算中",
      syncingTime: "同步時間中"
    },
    loginFirst: "請先登錄",
    sessionSyncing: "正在同步",
    openPrice: "開倉價",
    closePrice: "平倉價",
    profitLoss: "盈虧",
    actions: {
      rise: "買漲",
      fall: "買跌"
    },
    holdings: {
      current: "當前持倉",
      history: "歷史記錄",
      aiHistory: "AI 歷史記錄",
      empty: "暫無持倉",
      historyEmpty: "暫無歷史持倉",
      aiHistoryEmpty: "暫無 AI 歷史記錄"
    },
    buyModal: {
      title: "購買AI預測特權",
      description: "支付{amount}{symbol}即可獲得{times}次額外AI預測次數。",
      upgradeAmount: "升級金額",
      balance: "當前可用餘額",
      cancel: "取消購買",
      confirm: "確認購買",
      purchasing: "購買中...",
      purchaseSuccess: "購買成功",
      purchaseFailed: "購買失敗",
      dailyLimit: "每日最多可購買1次。"
    },
    noPredictionAlert: {
      title: "AI預測開啓失敗",
      description: "您的AI預測次數爲0，暫時不能使用AI預測功能，請購買後繼續使用。",
      cancel: "取消購買",
      confirm: "確認購買"
    },
    toasts: {
      deferredWaitSettlement: "預測已生成，請等待當前持倉結算後再下單",
      insuranceCancelFailed: "關閉失敗，可能有未結算訂單",
      insuranceTierUnavailable: "請先選擇保險檔位",
      amountTierMismatch: "輸入金額未匹配到保險檔位",
      bindStakeChanged: "服務端要求的本金與輸入不一致，已停止原下單",
      predictionFailed: "預測失敗",
      predictionSuccess: "預測完成",
      premiumShortfallReminder: "整輪預計保費缺口約 {amount} JOULE（提醒，本單仍可按策略倉位提交）",
      requiredStakeInvalid: "預測倉位無效，請重新開啓 AI 預測",
      resumeFailed: "恢復預測失敗，請稍後重試",
      onlyBtcUsdt1m: "AI 預測僅支持 BTC、原油、黃金的 1 分鐘模式",
      entryWindowExpired: "入場窗口已過期，請重新開啓 AI 預測",
      scheduleRoundRequired: "請先同步當前輪次",
      scheduleNotReady: "結果尚未公佈，請稍候",
      scheduleExpired: "本輪已截止，請等待下一輪",
      scheduleUnavailable: "定時預測暫不可用",
      unsettledConflict: "已有持倉未結算，請等待後再下單",
      orderWindowExpired: "下單時間已結束，請重新開啓 AI 預測"
    },
    previousOrder: {
      title: "上一單",
      won: "已盈利",
      lost: "已虧損",
      refunded: "已退款",
      pending: "待結算",
      review: "覈對中"
    },
    analyzing: "正在分析...",
    insurance: "保險",
    insuranceOn: "已生效",
    insuranceOff: "未生效",
    aiLabel: "AI",
    lookLong: "買漲",
    lookShort: "買跌",
    selfQuotaRemaining: "自主預測剩餘次數：{remaining}/{limit}",
    followRoundProgress: "AI帶單 · 第{current}/{total}輪",
    followRoundsCompleted: "AI帶單已完成 · {current}/{total}",
    selfQuotaLoadingShort: "次數加載中",
    selfQuotaLoginHint: "登錄後查看次數",
    selfQuotaLoading: "次數加載中，請稍後再試",
    selfQuotaExhausted: "今日免費自主預測次數已用完，付費預測暫未開放"
  },
  positionModal: {
    title: "漲幅預測",
    insurance: "保險",
    long: "買漲",
    short: "買跌",
    balance: "餘額",
    loading: "加載中...",
    confirm: "確認",
    processing: "預測下單中...",
    success: "預測下單成功！",
    insuranceOn: "已開啟",
    insuranceOff: "已關閉",
    operationFailed: "操作失敗",
    balanceFetchFailed: "獲取餘額失敗",
    minAmount: "最小金額為 1 JOULE",
    insufficientBalance: "餘額不足，當前餘額: {balance} TAKER",
    createFailed: "創建失敗",
    recoverTitle: "恢复未确认订单",
    recoverContent: "检测到未确认下单（{symbol} {direction} {amount}）。将使用原幂等键恢复，不会重新报价。",
    recoverConfirm: "恢复订单",
    recoverCancel: "取消"
  },
  appeal: {
    title: "資產輔助審核",
    records: "提交記錄",
    recordsTitle: "提交記錄",
    noRecords: "暫無提交記錄",
    submitTime: "提交時間",
    statusPending: "待處理",
    statusApproved: "通過",
    statusRejected: "駁回",
    failedReason: "拒絕原因",
    uniLiveUid: "UniLive ID",
    uniLiveUidLoading: "載入中...",
    walletAddress: "綁定 PANTA MARKET 的地址",
    address: "地址",
    walletAddressPlaceholder: "請輸入登入 PANTA MARKET的地址",
    autoFill: "自動填充",
    depositAmount: "充值金額",
    depositAmountPlaceholder: "請輸入充值金額",
    tokenType: "幣種",
    selectToken: "請選擇幣種",
    tokens: {
      usdt: "USDT",
      taker: "JOULE"
    },
    transferTime: "轉賬時間",
    selectTime: "請選擇轉賬時間",
    timeRangeHint: "2026年3月5日 00:00 至 3月11日 10:00（SGT）期間產生的相關數據。",
    txHash: "HASH / TXID",
    txHashPlaceholder: "請輸入交易哈希值",
    txHashHint: "可在區塊鏈瀏覽器中查詢",
    uploadImages: "轉賬記錄截圖",
    uploadHint: "選填，最多上傳9張圖片",
    addImage: "添加圖片",
    submit: "提交",
    submitting: "提交中...",
    submitSuccess: "提交成功",
    submitFailed: "提交失敗，請重試",
    uploadingImages: "上傳圖片中...",
    uploadImagesFailed: "圖片上傳失敗",
    warningTitle: "重要提示",
    warningText: "提交記錄通過驗證成功，同時獎勵申購算力的5%。如若虛假提供，凍結賬號。"
  },
  withdrawSheet: {
    title: "提現",
    balance: "餘額",
    processing: "JOULE 提現中...",
    success: "JOULE 提現成功！",
    withdrawing: "提現中...",
    withdrawSuccess: "提現已受理，請在記錄中查看進度",
    recordBadge: "提現記錄",
    sheetTitle: "提現 {token}",
    sheetDesc: "最低 {min} USDT，手續費以提交結果爲準",
    available: "可用 {token}",
    amountLabel: "提現金額",
    amountPlaceholder: "輸入金額（最低 {min} USDT）",
    vault: "Vault 合約",
    feeHint: "預估手續費僅供參考；最終以服務端創建響應的 fee/net 爲準"
  },
  depositSheet: {
    broadcastPending: "交易已廣播，正在同步充值狀態，請勿重複轉帳",
    broadcastSavedWarning: "交易已廣播，但本機記錄保存失敗，請保留雜湊聯繫管理員：",
    creditSummary: "充值 {input} USDT → 已兌換為 {output} {asset}",
    autoExchange: "充值的 USDT 將按到帳時匯率自動兌換為 Joule，免兌換手續費。",
    title: "存入 JOULE",
    depositTo: "充值至",
    spotAccount: "現貨賬戶",
    network: "網絡",
    networkWarning: "僅支持BSC/BEP20網絡充值，若使用其他網絡導致資產損失，無法找回",
    depositAddress: "收款地址",
    address: "地址",
    depositTAKER: "充值JOULE",
    generating: "生成中...",
    generateSuccess: "生成成功",
    generateFailed: "生成失敗",
    saveAndShare: "保存並分享地址",
    more: "更多",
    save: "保存",
    wechat: "微信",
    recordBadge: "充值記錄",
    sheetDesc: "從當前登錄錢包向收款地址轉入配置的 USDT",
    wallet: "錢包",
    max: "最大",
    telegram: "Telegram",
    discord: "Discord",
    x: "X",
    savedImage: "保存的圖片",
    download: "下載",
    pleaseGenerate: "請先生成圖片",
    downloadSuccess: "下載成功",
    saveSuccess: "保存成功",
    saveFailed: "保存失敗",
    pleaseUseDapp: "請使用錢包打開 DApp 操作",
    needPermission: "需要保存圖片到相冊的權限",
    recharge: "充值",
    rechargeAddress: "充值地址",
    copy: "複製",
    copySuccess: "複製成功",
    loadingAddress: "正在獲取充值地址...",
    loadAddressFailed: "獲取充值地址失敗",
    clickToRetry: "點擊重試",
    loading: "加載中...",
    loadFailed: "獲取充值地址失敗",
    claimButton: "認領充值",
    claimDesc: "向充值地址轉賬 USDT 後，粘貼交易哈希認領（受理≠到賬）",
    txHash: "交易哈希",
    txHashPlaceholder: "粘貼 0x 開頭的 64 位交易哈希",
    environment: "環境",
    envMainnet: "主網",
    envTestnet: "測試網",
    confirmations: "所需確認數",
    tokenContract: "USDT 合約",
    stepsTitle: "充值步驟",
    step1: "確認網絡與收款地址，僅向該地址轉賬配置的 USDT",
    step2: "在錢包完成鏈上轉賬",
    step3: "粘貼交易哈希並認領，在充值記錄中查看處理進度",
    optionalAmount: "金額（可選，僅備註）"
  },
  sidebar: {
    loginAccount: "登錄賬號",
    inviteBanner: "邀請好友拿團隊佣金",
    inviteCode: "邀請碼",
    defaultName: "PANTA MARKET",
    logoutWallet: "退出錢包登錄"
  },
  teamDetails: {
    myReferrals: "我的邀請",
    currentLevel: "當前等級：{level}",
    effectiveLevel: "當前有效等級：{level}",
    nextLevel: "下一等級",
    nextLevelClosed: "暫未開放",
    totalMembers: "直推人數",
    activatedCount: "激活人數",
    validMembers: "有效人數",
    teamLevel: "團隊等級: {level}",
    tradeTeam: "交易團隊",
    financeTeam: "基金團隊",
    predictTeam: "預測團隊",
    teamMembers: "團隊成員",
    teamData: "團隊數據",
    teamEarningsJoule: "團隊收益",
    teamFlowJoule: "團隊總流水",
    teamPowerUsdt: "團隊總流水",
    teamTotalCount: "團隊人數",
    teamEarningsWithUnit: "團隊收益（{unit}）",
    teamVolumeWithUnit: "團隊總流水（{unit}）",
    teamActiveStakeWithUnit: "團隊當前質押數量（{unit}）",
    effectiveTradingCount: "交易有效人數",
    activeInvestorCount: "基金在投人數",
    dividendEligibleCount: "分紅資格已激活人數",
    myTeamReward: "團隊收益",
    teamPerformance: "團隊總流水",
    directMembers: "團隊成員",
    filterAll: "全部",
    filterEffective: "業務有效",
    filterDividend: "分紅達標",
    filterDirect: "直推",
    filterIndirect: "間推",
    addRemark: "添加備註",
    editRemark: "修改備註",
    saveRemark: "修改",
    remarkPlaceholder: "請輸入備註",
    remarkSaved: "備註已保存",
    remarkFailed: "備註保存失敗",
    myCurrentLevel: "當前等級：{level}",
    personalTradePerf: "個人交易流水總業績：{value}",
    personalStakePerf: "個人質押流水總業績：{value}",
    currentTotalPerf: "本人升級業績：{value}",
    currentAreaPerf: "團隊升級業績：{value}",
    viewingIndirect: "{name}的直推",
    includesAllLevels: "含全部層級",
    inviteDetails: "邀請明細",
    startDate: "開始日期",
    endDate: "結束日期",
    dateTo: "至",
    status: "狀態：",
    statusActivated: "已激活",
    statusNotActivated: "未激活",
    statusDividendActivated: "分紅資格已激活",
    statusDividendNotActivated: "分紅資格未激活",
    statusValid: "已激活",
    statusInvalid: "未激活",
    time: "綁定時間",
    bindTime: "綁定時間",
    level: "等級",
    tradeLevel: "交易等級",
    fundLevel: "基金等級",
    inviteType: "邀請類型",
    viewTeam: "團隊詳情",
    viewDetail: "查看詳細",
    noSubMembers: "該成員暫無直推",
    directCount: "直推人數",
    teamSize: "團隊人數",
    teamTotalPerf: "團隊總業績",
    teamTotalStake: "團隊當前質押數量",
    personalTotalPerf: "個人總業績",
    personalTotalStake: "個人當前質押數量",
    settledOrderCount: "累計已結算訂單數",
    activeSubscriptionCount: "有效在投套餐數",
    eventContractParticipants: "累計已結算訂單數",
    communityValidCount: "分紅達標：",
    communityTotalPerf: "本人業績：",
    areaTotalPerf: "有效質押：",
    yesterdayStake: "昨日新增質押數量：",
    communityMaxLevel: "社區最高等級：",
    personalEquity: "個人權益金：",
    peopleUnit: "{n}人",
    loadFailed: "加載失敗，請重試",
    forbidden: "無權查看該團隊"
  },
  teamMemberModal: {
    totalProfit: "總收益",
    totalFlow: "總流水",
    totalInvites: "總邀請人數",
    validMembers: "總有效人數"
  },
  fundRecords: {
    depositTitle: "充值記錄",
    withdrawTitle: "提現記錄",
    exchangeTitle: "兌換記錄",
    feeLabel: "手續費: {fee}",
    detailTitle: "記錄詳情",
    statusLabel: "狀態",
    amountLabel: "金額",
    ledgerTitle: "關聯流水",
    ledgerEmpty: "暫無關聯流水",
    claimHint: "申報記錄，金額以關聯轉賬爲準",
    confirmProgress: "確認數 {cur}/{req}",
    depositStatus: {
      PENDING_CHAIN: "等待鏈上交易",
      PENDING: "處理中",
      UNMATCHED: "未匹配到轉賬",
      CONFIRMING: "已識別，等待確認",
      CONFIRMED: "鏈上覈驗完成，等待入賬",
      CREDITED: "已到賬",
      REJECTED: "覈驗失敗",
      MANUAL_REVIEW: "異常複覈中",
      REORGED: "鏈重組待複覈",
      VERIFIED: "已覈驗"
    },
    withdrawStatus: {
      PENDING_REVIEW: "等待審覈",
      AUTHORIZED: "已審覈，等待鏈上執行",
      BROADCASTING: "鏈上交易已發送，等待確認",
      CONFIRMED: "提現完成",
      REJECTED: "審覈拒絕，資金已解凍",
      EXPIRED: "授權過期",
      MANUAL_REVIEW: "鏈上憑據異常，人工複覈中"
    }
  },
  aiAssistant: {
    title: "PANTA MARKET",
    newChat: "新對話",
    manual: "操作手冊",
    manualCardTitle: "查看操作手冊",
    manualCardDesc: "充值、兌換、劃轉與 AI 預測完整圖文步驟",
    hello: "你好，我是 AI 客服",
    hint: "可問行情分析、事件合約/AI 預測規則怎麼看、團隊與邀請入口，或風險提示。",
    placeholder: "問點什麼...",
    send: "發送",
    thinking: "分析中...",
    disclaimer: "內容僅供參考，不構成投資建議。",
    bullish: "看漲",
    bearish: "看跌",
    aiAnalysis: "AI 智慧總結",
    strategy: "交易策略",
    reasoning: "推理分析",
    targetPrice: "目標價 {price}",
    stopLoss: "止損 {price}",
    takeProfit: "止盈 {price}",
    dirLong: "偏多",
    dirShort: "偏空",
    dirNeutral: "中性",
    analysisDone: "已完成 {symbol}（{timeframe}）分析，詳見下方卡片。",
    analysisBtc: "已為你生成 BTC 短線分析。",
    analysisEth: "已為你生成 ETH 震盪分析。",
    analysisRisk: "以下是市場風險解讀。",
    suggestions: {
      btc1m: "幫我分析 BTCUSDT 1 分鐘短線走勢",
      ethTrend: "ETH 現在適合追漲還是觀望？",
      marketRisk: "當前市場風險偏好如何？要注意什麼？",
      eventRules: "事件合約保險規則速覽在哪看？",
      aiRules: "AI 預測規則和檔位怎麼理解？",
      teamWhere: "團隊詳情在哪裡查看？",
      inviteWhere: "邀請連結和綁定上級在哪？"
    },
    guides: {
      eventRules: "事件合約保險規則：進入「事件合約」交易頁，打開保險開關旁的規則入口，可看「速覽」與「完整協議」。速覽含開啟保費、下單閾值、賠付權益與保險池等要點；完整協議為正式條款全文。",
      aiRules: "AI 預測：打開底部中間入口進入「AI 預測」。可查看下一輪倒計時、保險檔位/步數、自主預測剩餘次數。規則同樣在保險規則彈窗的 AI 速覽與完整協議中說明；下單需匹配檔位金額與方向。",
      teamWhere: "團隊詳情：側邊欄或「我的」→「我的團隊」，可切換交易收益/理財收益，點「團隊明細」查看直推、流水、等級與成員；再點成員可下鑽直推列表。",
      inviteWhere: "邀請與綁定：側邊欄/我的 →「邀請好友」可複製分享連結（含 ?ref=）。未綁定上級時登入後會彈出「綁定上級」；也可在邀請頁手動填寫。無邀請參數時輸入框會預填環境變數中的預設上級地址。"
    },
    generic: {
      a: "已收到。可問行情、事件合約/AI 規則入口、團隊與邀請位置，或點下方快捷問題。",
      b: "好的。我會給方向機率與策略要點，也可指路平台功能入口。",
      c: "收到。試試「事件合約規則」「AI 預測規則」「團隊詳情」「邀請連結」等快捷問題。"
    }
  },
  createMarket: {
    title: "创建市场",
    saveDraft: "保存草稿",
    marketTitle: "市场标题",
    titlePlaceholder: "请输入标题",
    category: "类别",
    secondaryOptional: "二级（可选）",
    deadline: "截止日期",
    optionsTitle: "预测结果（2~16 个）",
    optionsSub: "为每个选项命名",
    resetDefault: "重置默认",
    addOption: "+ 添加选项",
    ratioHint: "初始比例：全部留空则均分；填写则每个选项都要填（1~99 的整数），合计须为 100。",
    rulesSection: "规则说明 / 结算来源",
    rulesSectionSub: "可选，提示在详情页的规则与结算来源弹窗",
    rulesLabel: "规则说明",
    rulesPlaceholder: "结算判定、边界情况等",
    settleLabel: "结算来源",
    settlePlaceholder: "官方网站 / 头部新闻 / URL",
    liquidityTitle: "初始流动性",
    liquiditySub: "引导市场启动所需的资金",
    enabled: "已启用",
    disabled: "已关闭",
    investAmount: "投入金额 (JOULE)",
    balance: "余额: {n}",
    max: "最大",
    initialLiquidity: "初始流动性",
    marginRefund: "保证金（结算后退还）",
    totalTip: "保证金与流动性等额，事件结算或取消后全部退还。",
    totalDeduct: "合计扣除",
    feeTip: "提示：每次在该市场发生的交易，您都将获得 0.5% 的创建者手续费。",
    accessPassword: "访问密码",
    accessPasswordSub: "事件将带锁形标识上架，只有拿到分享链接或知道密码的人才能进入。",
    passwordPlaceholder: "设置密码（4~20 位）",
    hide: "隐藏",
    show: "显示",
    cardPreview: "卡片预览",
    deadlinePrefix: "截止 {date}",
    submitting: "创建中...",
    submit: "确认并创建流动性",
    createSuccess: "创建成功",
    creating: "正在创建",
    creatingDesc: "请稍候，正在提交市场信息…",
    backHome: "返回首页",
    createAnother: "再创建一个",
    deadlineShort: "{m}月{d}日",
    yes: "是",
    no: "否",
    optionN: "选项{n}",
    draftSaved: "草稿已保存",
    draftSaveFailed: "草稿保存失败",
    resetDone: "已重置为默认选项",
    maxOptions: "最多 16 个选项",
    minOptions: "至少保留 2 个选项",
    needMinOptions: "至少需要 2 个选项",
    fillOptionName: "请填写第 {n} 个选项名称",
    fillAllPercents: "填写比例时每个选项都要填",
    percentRange: "比例须为 1~99 的整数",
    percentSum: "比例合计须为 100（当前 {sum}）",
    enterTitle: "请输入市场标题",
    enterAmount: "请输入投入金额",
    insufficientBalance: "余额不足（含等额保证金）",
    passwordLength: "密码需 4~20 位",
    deadlineFuture: "截止日期须晚于当前时间",
    completeForm: "请完善信息",
    createdMsg: "「{title}」已创建，截止 {date} {time}"
  },
  marketDetail: {
    tabTrades: "最近成交",
    tabLp: "LP",
    tabPositions: "持倉",
    tabRules: "規則",
    colAddress: "地址",
    colTime: "時間",
    colType: "類型",
    colVolumePrice: "成交量/成交價",
    colTurnover: "成交額",
    typeBuy: "買入",
    typeSell: "賣出",
    empty: "暫無數據",
    share: "分享",
    rulesBody: "本市場爲二元事件預測。結算前盤口可能鎖定，鎖定後等待結果公示並按持倉份額結算。請注意市場風險，理性參與。",
    priceJoule: "價格 (JOULE)",
    investJoule: "投入 (JOULE)",
    totalLiquidity: "總流動性",
    dealPrice: "成交價",
    estProfit: "預計收益",
    jouleBalance: "JOULE 餘額: {n}",
    positionCount: "持倉張數: {n}",
    max: "最大",
    confirmOrder: "確認下單",
    ordering: "下單中...",
    enterAmount: "請輸入投入金額",
    invalidPrice: "請輸入有效價格",
    amountExceed: "投入超過可用餘額",
    orderSuccess: "下單成功",
    poolSize: "池子大小",
    colBalance: "餘額",
    shares: "{n}張",
    rulesTitle: "規則說明",
    rulesValue: "暫無說明",
    settleSource: "結算來源",
    settleValue: "暫無說明"
  },
  rank: {
    applyTitle: "申请成为达人",
    applyDesc: "展示您的交易才华，赢取收益分成",
    applyCta: "立即入驻",
    tabExpert: "达人排行榜",
    tabMaker: "做市商排行榜",
    tabWinRate: "胜率榜",
    tabProfit: "盈利榜",
    experts: {
      trendCatcher: "趋势捕捉者",
      whaleWatcher: "巨鲸观察家",
      cryptoWolf: "币圈老狼",
      swingCaptain: "波段队长",
      arbHunter: "套利猎手",
      bullKnight: "牛市骑士"
    },
    tagPolitics: "政治",
    tagEsports: "电竞",
    comingSoon: "敬请期待"
  },
  operationManual: {
    title: "操作手冊",
    docTitle: "PANTA MARKET 操作手冊",
    sourceHint: "圖文步驟復刻自官方操作手冊，可點擊截圖放大查看。"
  },
  pantaMarket: {
    title: "Panta Market",
    tokenSection: "PANTA協議治理代幣",
    todayBurn: "今日銷毀",
    totalBurn: "累計銷毀",
    burned: "已銷毀",
    initialSupply: "初始發行量",
    maxSupply: "最大發行量",
    finalCirculation: "最終流通量",
    contractAddress: "合約地址：",
    copied: "已複製",
    ecoSection: "PANTA · AI應用生態",
    ecoTabs: {
      market: "行情分析",
      arbitrage: "套利工具",
      acquisition: "全球獲客",
      video: "視頻創作"
    },
    apps: {
      pantaAi: "Panta AI",
      asiStar: "ASI Star",
      tatianaTv: "Tatiana TV",
      tokenSpace: "Token space"
    },
    groupSection: "PANTA ·創意拼團",
    groupTabs: {
      recommend: "推薦",
      hot: "熱門",
      ipDrama: "IP短劇",
      ipCollab: "IP共創",
      data: "數據"
    },
    filters: {
      all: "全部推薦",
      new: "新品首發",
      ending: "即將結束",
      highScore: "AI高分評價"
    },
    project: {
      badge: "星球首發",
      title: "《Panta AI · 崛起》AI動畫短劇",
      score: "AI評分92",
      tagDrama: "IP短劇",
      tagRights: "確權項目#0001",
      desc: "Panta AI帶我逆風翻盤，AI應用教學短劇"
    },
    values: {
      todayBurn: "321枚",
      totalBurn: "4212枚",
      initialSupply: "1000萬枚",
      maxSupply: "2.1億枚",
      finalCirculation: "2100萬枚"
    }
  },
  copyTrade: {
    menuTitle: "跟單",
    pageTitle: "跟單",
    fallback: "操作失敗，請稍後重試",
    pauseRule:
      "若本週結算完成時仍處於暫停，下週將自動取消跟單關係。",
    pauseSuccess: "暫停成功",
    resumeSuccess: "已恢復",
    endSuccess: "已結束",
    followSuccess: "跟單成功",
    pendingReviewToast: "待達人審核",
    savedSuccess: "已儲存",
    registerSuccess: "註冊成功，保證金已凍結",
    cancelRequested: "已申請註銷",
    cancelWithdrawn: "已撤回註銷",
    kickedSuccess: "已移出",
    approvedSuccess: "已通過",
    rejectedSuccess: "已拒絕",
    filledToForm: "已填入跟單表單",
    traderNotFound: {
      search: "該地址不是達人",
      business: "該達人暫不可用",
    },
    tabs: {
      board: "排行榜",
      follows: "我的跟單",
      join: "去跟單",
      trader: "帶單",
      apps: "申請",
      fans: "跟隨者",
      rules: "規則",
      settings: "規則",
      follow: "去跟單",
    },
    ui: {
      refresh: "重新整理",
      search: "搜尋",
      loginWallet: "登入錢包",
      needLoginAction: "該操作需要錢包登入，與下單相同。",
      needLoginTrader: "達人相關介面需要登入。",
      loginToView: "登入後可查看",
      loading: "載入中…",
      empty: "暫無",
      readonly: "唯讀",
      yes: "是",
      no: "否",
      immediate: "立即生效",
      current: "目前",
      nextWeek: "下週",
      pause: "暫停",
      resume: "恢復",
      end: "結束",
      save: "儲存",
      kick: "踢出",
      approve: "通過",
      reject: "拒絕",
      requestCancel: "申請註銷",
      withdrawCancel: "撤回註銷",
      confirmFollow: "確認跟單",
      registerWithDeposit: "凍結保證金並註冊",
      registerConfirmTitle: "確認註冊",
      registerFreezeConfirm: "交易賬戶將凍結{amount}JOULE保證金。",
      platformSettings: "平台配置",
      settingsTip:
        "只複製普通模式且已開啟保險的帶單訂單。未投保的普通單和 AI 單不會跟，跟隨生成的 COPY 單也不會再帶單。達人請用現有下單介面，不要傳 orderSource。跟單者在訂單列表能看到 COPY 單。金額只顯示兩位小數，多出來的直接截掉。",
      deposit: "保證金",
      depositFreezeWeeks: "保證金凍結週數",
      maxFollowers: "人數上限",
      shareRateRange: "分潤區間",
      shareRateDefault: "預設分潤",
      shareRateNextWeek: "分潤下週生效",
      pendingShareHint: "下週一生效：{rate}",
      pendingMaxFollowersHint: "下週一生效：{n}",
      depositFrozenShort: "仍凍結",
      minFollowStake: "最低跟單本金",
      ratioRange: "等比區間",
      maxSimultaneousFollows: "同時跟達人數",
      defaultReview: "預設審核",
      defaultMinBalance: "預設餘額門檻",
      settlementTimezone: "結算時區",
      leaderboardMeta: "榜單門檻/條數",
      leaderboardMetaValue: "{min} 場 / {size} 條",
      weekLeaderboard: "本週勝率榜",
      expertLeaderboard: "達人排行榜",
      heroTitle: "成為實力達人",
      heroDesc: "開啟您的帶單交易，賺取收益分潤",
      heroActiveTitle: "已成為實力達人",
      heroActiveDesc: "您已開啟跟單交易身份，帶單進行中",
      heroRegister: "註冊達人",
      heroSettings: "帶單設定",
      myLeading: "我的帶單",
      winRateBoard: "勝率榜",
      pnlBoard: "盈利榜",
      searchAddress: "搜尋地址",
      searchNicknameOrAddress: "搜尋暱稱或地址",
      searchQueryTooShort: "請至少輸入 2 個字元",
      winRateShort: "勝率",
      followersLabel: "跟單人數:",
      shareRateLabel: "分潤比例:",
      roundPnlLabel: "本輪盈虧:",
      settledOrders: "已結 {n} 場",
      activeCount: "進行中",
      followStatsShort: "分潤池 {pool} · 暫存 {cash}",
      traderSettings: "帶單設定",
      confirmChanges: "確認修改",
      confirmCancel: "確認註銷",
      cancelModalTitle: "註銷說明",
      activeInProgress: "全部進行中",
      leadingFollowerCount: "跟單人數 {n}",
      auditApps: "審核申請 {n}",
      leaderboardNote:
        "只統計本週、普通來源且已投保的已贏／已輸訂單，達到最低場次才上榜。不是全歷史勝率，也不是 AI 勝率。沒有團隊名稱和累計跟單額。",
      weekStart: "週起始（週一）：{date}",
      leaderboardEmpty: "暫無上榜達人，可搜尋完整地址跟單",
      winRate: "勝率 {n}%",
      boardSub:
        "分潤 {share} · 跟單 {followers}/{max} · 已結 {orders} 場 · 本週盈虧 {pnl} JOULE",
      searchTrader: "搜尋達人",
      walletPlaceholder: "完整錢包地址 0x…",
      address: "地址",
      status: "狀態",
      shareRate: "分潤",
      review: "審核",
      minBalance: "餘額門檻",
      followerCount: "人數",
      startFollow: "發起跟單",
      traderWallet: "達人地址",
      followMode: "跟單方式",
      ratioLabel: "等比（%），區間 {min} ~ {max}",
      insuranceMode: "保險策略",
      takeProfit: "止盈（JOULE，可選）",
      stopLoss: "止損（JOULE，可選）",
      takeProfitPh: "本週淨盈虧達標後暫停",
      stopLossPh: "本週淨虧損達標後暫停",
      followHint:
        "每位用戶同時最多可跟隨 {n} 位達人。達到上限後發起新跟單時，系統將先行終止既有跟單關係；該操作即時生效，並非預覽。跟單參數不可單獨修改；如需調整，請先結束目前關係後再重新跟單。",
      endConfirm:
        "確認結束與該達人的跟單關係？結束後將不再跟隨其交易信號；歷史訂單及已結算盈虧不受影響。",
      weeklyPoolHint: "分潤池是本週池子，不是累計跟單金額。已結束關係和待審核申請不在這份列表裡。",
      networkUnclear:
        "結果未確認。請先重新整理查看目前關係或達人身份，確認沒有成功後再重試。",
      myFollows: "我的跟單",
      noFollows: "暫無跟單關係",
      followSub:
        "{mode}{ratio} · {insurance} · 本週鎖定分潤 {share}",
      followStats:
        "本週淨盈虧 {pnl} · 分潤池 {pool} · 暫存 {cash}",
      pauseReason: "暫停原因：{reason}",
      registerTrader: "註冊達人",
      registerHint:
        "註冊條件：需一次性繳納 {amount} JOULE 作為帶單保證金，帶單期間保證金持續凍結，註銷身份後審核退回。一個錢包地址只能註冊一個達人身份！",
      registerBalanceHint:
        "凍結保證金 {deposit} JOULE 後，帳戶可用餘額仍須 ≥ {remain} JOULE 才能完成註冊。",
      shareRateInput:
        "分潤比例（%）區間 {min} ~ {max}，修改後下一週期生效。",
      maxFollowersInput: "跟單上限（≤ {max}）",
      reviewMode: "通過方式",
      minBalanceInput: "跟單用戶餘額門檻 · 可選（JOULE）",
      myTrader: "我的達人身份",
      depositHeld: "{amount} / 凍結 {held}",
      currentFollowers: "目前跟單人數",
      cancelEffective: "註銷生效",
      depositRelease: "保證金退回",
      editParams: "修改參數",
      editHint:
        "分潤/人數寫入下週生效；審核與門檻立即生效。結算限制窗口為新加坡時間週日 22:00 至週一 01:00 前，以服務端為準，不要在週一 0:00 自行恢復修改。",
      shareRatePercent: "分潤比例（%）",
      minBalanceJoule: "餘額門檻（JOULE）",
      cancelTip:
        "註銷後本週仍帶單，下週一 0:00 身份失效；保證金再凍一整週後退回。失效前可撤回。",
      followers: "跟單用戶",
      followerSub: "{mode}{ratio} · 本週盈虧 {pnl} · 暫存 {cash}",
      applications: "待審核",
      noApplications: "暫無申請",
      fillForm: "填入跟單表單",
      needTraderFirst: "請先註冊帶單身份",
      cancelRequestedAt: "申請註銷時間",
      ratioRangeInvalid: "等比需在 {min} ~ {max} 之間",
      shareRangeInvalid: "分潤需在 {min} ~ {max} 之間",
      maxFollowersInvalid: "人數上限不能超過 {max}",
      needShareRate: "請填寫分潤比例",
      needMaxFollowers: "請填寫人數上限",
      needRatio: "請填寫等比比例",
      badTakeProfit: "止盈金額不正確",
      badStopLoss: "止損金額不正確",
      badMinBalance: "餘額門檻不正確",
      insuranceShortFollow: "跟隨",
      insuranceShortOn: "常開",
      insuranceShortOff: "常關",
      symbolSettings: "跟單選項設置",
      symbolPickHint: "初始預設全部關閉，需手動開啟，可隨時修改",
      followSymbolHint: "只能從該達人已開放的幣種裡選擇，至少開啟一個。",
      followSymbolWait: "請先搜尋達人，再選擇要跟隨的幣種。",
      symbolNeedOne: "請至少開啟一個幣種",
      symbolNotAllowed: "所選幣種不在達人允許範圍內",
      effectiveSymbols: "實際跟隨",
      editSymbols: "修改幣種",
      allowedSymbols: "開放幣種",
      weekPnlLabel: "本週盈虧:",
      currentNetPnlLabel: "當前淨盈虧",
      categoryCrypto: "加密貨幣",
      categoryCommodity: "大宗商品",
      categoryEquity: "股票",
      symbolListCol: "列表",
      symbolLeadCol: "是否帶單",
      symbolFollowCol: "是否跟單",
      symbolTags: "開放",
      leadingSymbols: "帶單信息",
      detail: "明細",
      enabled: "開啟",
      disabled: "關閉",
      held: "已持倉",
      notHeld: "未持倉",
      weekSettledOrders: "本輪已結場",
      historicalNetPnl: "歷史總盈虧",
      copyTotalPnl: "跟單總盈虧",
      historicalSharePayout: "歷史分潤總額",
      allOrders: "全部",
      prevPage: "上一頁",
      nextPage: "下一頁",
      pageOf: "{page} / {totalPages}",
      jumpToPage: "跳至",
      jumpConfirm: "確定",
      openOrders: "進行中",
      settledOrdersTab: "已完成",
      colInterval: "時長",
      colOrderTime: "下單時間",
      colSelfPnl: "自身盈虧(含保費)",
      colEstShare: "預估分潤",
      traderOrdersTitle: "{symbol} 帶單明細",
      followOrdersTitle: "{symbol} 跟單明細",
      selfPnl: "自身盈虧",
      estimatedShare: "預估分成",
      inProgress: "進行中",
      followAssets: "按資產盈虧",
      byAsset: "按資產",
      followHistory: "已結束",
      followStartTime: "開始時間：",
      followEndTime: "結束時間：",
      myPendingApps: "待審核",
      cashHeldHint: "本輪預估待扣分潤 {cash} JOULE",
      cashHeldFrozen: "本輪當前預估扣除分潤：{cash}（JOULE，已凍結）",
      followedTrader: "跟單達人",
      followInfo: "跟單資訊",
      totalPnlJoule: "總盈虧 (JOULE)",
      colTrader: "達人",
      colPrincipal: "本金",
      colPnlShare: "盈虧(含保費)/分潤(JOULE)",
      traderInfo: "達人資訊",
      traderNotFound: "該地址不是達人",
      followSettingsRelationHint:
        "跟單方式、保險策略與止盈止損為整段關係一份配置，對目前勾選的全部幣種一併生效。可隨時在「跟單設置」中修改。",
      followSettingsPrepareHint: "確認後，對勾選的幣種使用同一套跟單配置發起跟單。",
      followOptions: "跟單選項",
      noFollowOptions: "暫無跟單選項~",
      symbolFollowing: "已跟單",
      symbolPaused: "已暫停",
      symbolIdle: "未跟",
      cancelFollowSymbol: "取消跟單",
      cancelSymbolConfirm: "取消跟隨 {symbol}？",
      cancelLastSymbolConfirm: "這是最後一個跟隨幣種，取消後將結束整段跟單關係。確認？",
      followNow: "立即跟單",
      followAll: "跟單",
      unfollowAll: "解除跟單",
      unfollowAllConfirm: "確認取消跟隨該達人的全部交易對？結束後將解除整段跟單關係。",
      followSettings: "跟單設置",
      goFollowSettings: "前往 ›",
      copyAccountBalance: "跟單賬戶：{amount} JOULE",
      orderFollowerCount: "跟單人數",
      copyingStatus: "跟單中",
      roleStatusLeading: "帶單中",
      roleStatusFollowing: "跟單中",
      roleStatusPaused: "跟單已暫停",
      copyOrderTag: "跟單",
      copyOpenPositions: "當前跟單持倉",
      copyInsuredOrdinary: "已持普通保險",
      copyUninsured: "未投保",
      addSymbolHint: "將把該幣種加入當前跟單關係。",
      myRelationStatus: "我的跟單",
      latestSettlements: "最新結算",
      resumeRelationFirst: "關係已整段暫停，請先在「我的跟單」恢復後再按幣種操作",
      resumeStopLossHint: "目前已虧損 {amount}，請將止損金額設置在 {amount} 以上以繼續跟單",
      resumeTakeProfitHint: "目前已盈利 {amount}，請將止盈金額設置在 {amount} 以上以繼續跟單",
      resumeStartFollow: "開始跟單",
      colType: "類型",
      colPnlJoule: "盈虧 (JOULE)",
      tpSl: "止盈止損",
      takeProfitPhFull: "本輪淨盈利達到後暫停跟單 - 可選（JOULE）",
      stopLossPhFull: "本輪淨虧損達到後暫停跟單 - 可選（JOULE）",
      confirmModify: "確認修改",
      clearSearch: "返回榜單",
      searchResultHint: "搜尋結果（點擊進入達人信息）",
      searchEmpty: "該地址不是達人",
      noMoreSettlements: "沒有更多了",
    },
    errors: {
      AUTH_REQUIRED: "請先登入錢包",
      AUTH_UNAVAILABLE: "登入服務暫不可用，請稍後重試",
      POSTGRES_REQUIRED: "服務暫不可用，請稍後重試",
      USER_NOT_FOUND: "用戶不存在，請重新登入後再試",
      INVALID_WALLET: "請輸入完整的錢包地址",
      INVALID_QUERY: "搜尋關鍵詞無效，請至少輸入 2 個字元",
      INVALID_AMOUNT: "金額格式不正確",
      INVALID_PARAM: "參數不合法，請檢查後重試",
      INVALID_FOLLOW: "不能跟自己的單",
      TRADER_EXISTS: "該錢包已是達人，無需重複註冊",
      TRADER_FULL: "該達人跟單人數已滿",
      TRADER_CANCELLED: "該達人身份已註銷",
      TRADER_REGISTER_FAILED: "註冊達人失敗，請稍後重試",
      TRADER_SETTINGS_FAILED: "儲存達人設定失敗，請稍後重試",
      NOT_A_TRADER: "請先註冊達人身份",
      TRADER_UNAVAILABLE: "該達人暫不可用",
      INSUFFICIENT_BALANCE: "可用餘額不足，無法凍結保證金",
      BALANCE_TOO_LOW: "跟單賬戶可用餘額未達到該達人門檻，請先從交易賬戶劃轉",
      COPY_BALANCE_ZERO: "跟單賬戶餘額為 0，請先從交易賬戶劃轉",
      INSUFFICIENT_FUNDS: "交易賬戶餘額不足，無法劃入跟單賬戶",
      COPY_TRADE_BALANCE_INSUFFICIENT: "跟單賬戶可用不足（凍結本金/分潤不可劃出）",
      ACCOUNT_NOT_FOUND: "帳戶異常，請稍後重試",
      ACCOUNT_CONFLICT: "帳戶正在變動，請稍後重試",
      FOLLOW_EXISTS: "你已在跟該達人",
      FOLLOW_LIMIT: "你已有進行中的跟單，請先結束後再跟其他達人",
      FOLLOW_FAILED: "發起跟單失敗，請稍後重試",
      FOLLOW_NOT_FOUND: "跟單關係不存在或不屬於當前用戶",
      PAUSE_FAILED: "暫停跟單失敗，請稍後重試",
      RESUME_FAILED: "恢復跟單失敗，請稍後重試",
      STOP_LOSS_THRESHOLD: "止損金額仍不夠高，請調高或清空後再恢復",
      TAKE_PROFIT_THRESHOLD: "止盈金額仍不夠高，請調高或清空後再恢復",
      END_FAILED: "結束跟單失敗，請稍後重試",
      APPLICATION_NOT_FOUND: "待審申請不存在或不屬於當前用戶",
      APPROVE_FAILED: "審核通過失敗，請稍後重試",
      REJECT_FAILED: "拒絕申請失敗，請稍後重試",
      KICK_FAILED: "移出跟單用戶失敗，請稍後重試",
      SETTLEMENT_WINDOW: "結算窗口內暫不可修改達人參數",
      CANCEL_FAILED: "申請註銷失敗，請稍後重試",
      CANCEL_NOT_PENDING: "目前沒有可撤回的註銷申請",
      CANCEL_WITHDRAW_FAILED: "撤回註銷失敗，請稍後重試",
      COPY_SETTINGS_MISSING: "跟單配置未就緒，請稍後重試",
      INVALID_SYMBOL: "請選擇至少一個支援的幣種",
      SYMBOL_NOT_ALLOWED: "包含達人未開放的幣種",
      TRADER_BALANCE_TOO_LOW: "凍完保證金後可用餘額不足，無法註冊達人",
      TIMEOUT: "操作失敗，請稍後重試",
      NETWORK: "操作失敗，請稍後重試",
    },
    status: {
      ACTIVE: "跟單中",
      PAUSED: "已暫停",
      ENDED: "已結束",
      PENDING_REVIEW: "待達人審核",
      CANCEL_PENDING: "註銷中",
      CANCELLED: "已註銷",
    },
    traderStatus: {
      ACTIVE: "帶單中",
      CANCEL_PENDING: "退出中",
      CANCELLED: "已取消",
    },
    pauseReason: {
      USER: "用戶暫停",
      INSUFFICIENT_BALANCE: "跟單賬戶餘額不足已暫停",
      TAKE_PROFIT: "止盈觸發",
      STOP_LOSS: "止損觸發",
      TRADER_KICK: "達人移出",
      SWITCH: "已更換達人",
      SETTLEMENT_CLEANUP: "週結算自動移除",
      TRADER_CANCEL: "達人註銷",
    },
    followMode: {
      EQUAL: "等額",
      RATIO: "等比",
    },
    insuranceMode: {
      FOLLOW: "跟隨達人",
      ALWAYS_ON: "常開保險",
      ALWAYS_OFF: "常關保險",
    },
    reviewMode: {
      AUTO: "自動跟單",
      MANUAL: "審核跟單",
    },
    applicationStatus: {
      PENDING: "待審核",
      APPROVED: "已通過",
      REJECTED: "已拒絕",
      CANCELLED: "已取消",
      PENDING_REVIEW: "待審核",
    },
  },
}
